import React, { useEffect, Fragment, useState } from 'react';
import { FieldArray, Field, Formik } from 'formik';
import * as Yup from 'yup';
import axios from 'axios';
import { useDispatch, useSelector } from 'react-redux';
import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleDown } from '@fortawesome/free-solid-svg-icons';
import Select from '@material-ui/core/Select';
import useStyles from './assetStyle';
import './styles.css';
import { createGenInfoRequestSave } from '../../store/actions/index';
import { CommonConfig } from '../../../../config/common-config';
import fieldDisable from '../../../../components/disableField/fieldDisable';
import { userType } from '../../../../config/usertypeValue';
import LoaderPopUp from '../../../../components/loaderpopup/loader';
import { dataValidationAssetsCheck } from './validateField';

export default function ClientAccordion4(props) {
    const classes = useStyles();
    const dispatch = useDispatch({});
    const [panel, setPanel] = React.useState('');
    const tempToken = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails.result);
    const userToken = tempToken && tempToken.data.token;
    const bearerToken = `Bearer ${userToken}`;
    const statusIDValue = useSelector((state) => state.serviceCheckListReducer.selectedStageId);
    const [checklist, setChecklist] = useState('');
    const checklistValues = checklist.checklistJson;
    const checklist1 = checklistValues && checklistValues.checklistL1;
    const checklist1que = checklist1 && checklist1.questions;
    const [URLValue, setURLValue] = useState();
    const statusId = (checklist && checklist.currentStage && checklist.currentStage.id) || statusIDValue;
    const tennantname = useSelector((state) => state.loginsuccessreducer.tennantName);
    const tennantnameValue = tennantname && tennantname.tennantName;
    const serviceIdValue = useSelector((state) => state.serviceCheckListReducer.serviceIdSelected);
    const userDetails = useSelector((state) => state.loginsuccessreducer.loggedInUserDetails);
    const usertype = userDetails.result && userDetails.result.data.features[5].branchName;
    const getgeninfofromDB = useSelector((state) => state.geninforeducer.getgeninfo);
    const dbValuesfromDB = getgeninfofromDB && getgeninfofromDB.questions;
    const imcNameSelected = useSelector((state) => state.serviceCheckListReducer.imcNameSelected);
    const [allCountries, setAllCountries] = useState([]);
    const [selectedCountry, setselectedCountry] = useState('');
    const [showLoader, setShowLoader] = useState(false);
    const [files, setFiles] = useState([]);

    const setCountry = (e) => {
        setselectedCountry(e.target.value);
        // fetchStateData(e.target.value);
    };

    const allCountryOptions = (ww) => {
        const OptionList = ww.map((data) => <option value={data.country_name}>{data.country_name}</option>);
        return OptionList;
    };

    const handleStateChange = (e) => {
        const {
            target: { value },
        } = e;
        if (value.length && !isNaN(parseFloat(value))) {
            const IndianCur = new Intl.NumberFormat('en-IN').format(parseFloat(value.replace(/,/g, '')));
            e.target.value = IndianCur;
            //console.log("Indian Currency", e.target.value);
        } else {
            e.target.value = value;
        }
    };

    useEffect(() => {
        // const bearerToken = `Bearer ${userToken}`;
        fetchCountryData();
        //console.log('userType.historyStageId, statusIDValue', userType.historyStageId, statusIDValue)
        if (userType.historyStageId <= statusIDValue) {
            //console.log('history view')
            axios
                .get(
                    `${CommonConfig.dev.baseUrl1}/api/itr/itrhistory-by-serviceIdandstageId/${
                        usertype === 'Ultimate Client' || usertype === 'EM' ? tennantnameValue : imcNameSelected
                    }/${serviceIdValue}/${userType.historyStageId}`,
                    {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    let tempObj = response.data;
                    tempObj['checklistJson'] = JSON.parse(response.data.checklistJson);
                    //console.log('JSON.parse(response.data)', tempObj)
                    setChecklist(tempObj);
                    setResponse(response);
                })
                .catch((error) => {});
        } else {
            //console.log('active view')
            axios
                .get(
                    `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                        usertype === 'Ultimate Client' || usertype === 'EM' ? tennantnameValue : imcNameSelected
                    }/${serviceIdValue}`,
                    {
                        // axios
                        //     .get(`${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${tennantnameValue}/${serviceIdValue}`, {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    setChecklist(response.data);
                    setResponse(response);
                })
                .catch((error) => {});
        }
        if (props.panel) {
            setPanel(props.panel);
        }
    }, [userToken, props]);

    const setResponse = (response) => {
        let temp = [];
        let flag = true;
        for (let i = 0; i < response.data.checklistJson.checklistL1.questions[8].subQuestion[0].fields.length; i++) {
            if (response.data.checklistJson.checklistL1.questions[8].subQuestion[0].fields[i].relevanceResponseAM === 'uploadFile') {
                flag = false;
                let tempObj = {
                    filePath: response.data.checklistJson.checklistL1.questions[8].subQuestion[0].fields[i].response,
                };
                temp.push(tempObj);
            }
        }
        if (!flag) {
            setFiles(temp);
        }
    };

    const fetchCountryData = () => {
        axios
            .get(`${CommonConfig.dev.baseUrl6050}/global/getCountries`, {
                headers: {
                    Authorization: bearerToken,
                },
            })
            .then((response) => {
                setAllCountries(response.data);
            })
            .catch((error) => {});
    };

    const initialValues = {
        firstName: checklist1 && checklist1.questions[0].fields[0].response,
        lastName: checklist1 && checklist1.questions[0].fields[1].response,
        fatherNamePan: checklist1 && checklist1.questions[0].fields[2].response,
        pan: checklist1 && checklist1.questions[0].fields[3].response,
        address1: checklist1 && checklist1.questions[0].fields[4].response,
        address2: checklist1 && checklist1.questions[0].fields[5].response,
        city: checklist1 && checklist1.questions[0].fields[6].response,
        state: checklist1 && checklist1.questions[0].fields[7].response,
        country: checklist1 && checklist1.questions[0].fields[8].response,
        pin: checklist1 && checklist1.questions[0].fields[9].response,
        dob: checklist1 && checklist1.questions[0].fields[10].response,
        mobileNo: checklist1 && checklist1.questions[0].fields[11].response,
        emailaddress: checklist1 && checklist1.questions[0].fields[12].response,
        passport: checklist1 && checklist1.questions[0].fields[13].response,
        govIDType: checklist1 && checklist1.questions[0].fields[14].response,
        govIDNumber: checklist1 && checklist1.questions[0].fields[15].response,
        URLValue: checklist1 && checklist1.questions[0].fields[16].response,
        radiodata: checklist1 && checklist1.questions[0].fields[17].response,
        GSTIN: checklist1 && checklist1.questions[0].fields[18].response,

        panFile:
            checklist1 &&
            checklist1.questions &&
            checklist1.questions[0] &&
            checklist1.questions[0].fields &&
            checklist1.questions[0].fields[19] &&
            checklist1.questions[0].fields[19].response,
        aadharFile:
            checklist1 &&
            checklist1.questions &&
            checklist1.questions[0] &&
            checklist1.questions[0].fields &&
            checklist1.questions[0].fields[20] &&
            checklist1.questions[0].fields[20].response,
        enrollmentFile:
            checklist1 &&
            checklist1.questions &&
            checklist1.questions[0] &&
            checklist1.questions[0].fields &&
            checklist1.questions[0].fields[21] &&
            checklist1.questions[0].fields[21].response,
        gstFile:
            checklist1 &&
            checklist1.questions &&
            checklist1.questions[0] &&
            checklist1.questions[0].fields &&
            checklist1.questions[0].fields[22] &&
            checklist1.questions[0].fields[22].response,

        // screen 3 - Tab 1 - Salary
        nameEmployer: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[1].response,
        salaryradiodata: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[0].response,
        //screen 3 - Tab 2 - hosuse property
        incomeFromHouseProperty: (checklist1que && checklist1que[2].subQuestion[1].response) || 'Yes',
        // screeen 3 - Tab 3 -Business
        incomeFromBusinessProfesion: (checklist1que && checklist1que[2].subQuestion[2].response) || 'Yes',
        natureBusiness: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[0].response,
        natureBusinessCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[0].relevanceResponseCRC,
        natureBusinessCRCrelevenceRemarks:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[0].relevanceRemarksCRC,

        busProfincomeType: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[1].response,
        busProfincomeTypeCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[1].relevanceResponseCRC,
        busProfincomeTypeCRCrelevenceRemarks:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[1].relevanceRemarksCRC,

        totalReceipts: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[2].response,
        totalReceiptsCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[2].relevanceResponseCRC,
        totalReceiptsCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[2].relevanceRemarksCRC,

        totalExpenses: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[3].response,
        totalExpensesCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[3].relevanceResponseCRC,
        totalExpensesCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[3].relevanceRemarksCRC,

        gstReturnDoc: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[4].response,
        gstReturnDocCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[4].relevanceResponseCRC,
        gstReturnDocCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[4].relevanceRemarksCRC,

        otherStatement: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[5].response,
        otherStatementCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[5].relevanceResponseCRC,
        otherStatementCRCrelevenceRemarks:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[5].relevanceRemarksCRC,

        busProfType: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[6].response,
        busProfTypeCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[6].relevanceResponseCRC,
        busProfTypeCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[6].relevanceRemarksCRC,

        userIDtally: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[7].response,
        userIDtallyCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[7].relevanceResponseCRC,
        userIDtallyCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[7].relevanceRemarksCRC,

        passwordtally: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[8].response,
        passwordtallyCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[8].relevanceResponseCRC,
        passwordtallyCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[8].relevanceRemarksCRC,

        uploadTally: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[9].response,
        uploadTallyCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[9].relevanceResponseCRC,
        uploadTallyCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[9].relevanceRemarksCRC,

        userIDZoho: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[10].response,
        userIDZohoCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[10].relevanceResponseCRC,
        userIDZohoCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[10].relevanceRemarksCRC,

        passwordZoho: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[11].response,
        passwordZohoCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[11].relevanceResponseCRC,
        passwordZohoCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[11].relevanceRemarksCRC,

        accountDetails: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[12].response,
        accountDetailsCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[12].relevanceResponseCRC,
        accountDetailsCRCrelevenceRemarks:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[12].relevanceRemarksCRC,

        partnershipradio: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[13].response,
        partnershipradioCRCrelevenceResponse:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[13].relevanceResponseCRC,
        partnershipradioCRCrelevenceRemarks:
            checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[13].relevanceRemarksCRC,

        totalReceiptsUpload: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[14].response,
        totalExpensesUpload: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[15].response,
        gstUpload: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[16].response,
        statementUpload: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[17].response,

        userIDQB: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].response,
        userIDQBCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].relevanceResponseCRC,
        userIDQBCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].relevanceRemarksCRC,

        passwordQB: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].response,
        passwordQBCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].relevanceResponseCRC,
        passwordQBCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].relevanceRemarksCRC,

        //screen 3 - Tab 4 - capitalGain
        soldAnyAsset: (checklist1que && checklist1que[2].subQuestion[3].response) || 'Yes',
        //screen 3 - Tab 5 - OtherSources
        explicitlyUncoveredIncom: (checklist1que && checklist1que[2].subQuestion[4].response) || 'Yes',
        // screen 3 - Tab 6 - Agri
        agricultureIncome: (checklist1que && checklist1que[2].subQuestion[5].response) || 'Yes',
        agricultureName: checklist1que && checklist1que[2].subQuestion[5].fields[0].response,
        agricultureNameCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[0].relevanceResponseCRC,
        agricultureNameCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[0].relevanceRemarksCRC,
        agriAmount: checklist1que && checklist1que[2].subQuestion[5].fields[1].response,
        agriAmountCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[1].relevanceResponseCRC,
        agriAmountCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[1].relevanceRemarksCRC,
        agriReceipt: checklist1que && checklist1que[2].subQuestion[5].fields[2].response,
        agriReceiptCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[2].relevanceResponseCRC,
        agriReceiptCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[2].relevanceRemarksCRC,
        agriExpenses: checklist1que && checklist1que[2].subQuestion[5].fields[3].response,
        agriExpensesCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[3].relevanceResponseCRC,
        agriExpensesCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[3].relevanceRemarksCRC,
        agriReceiptUpload: checklist1que && checklist1que[2].subQuestion[5].fields[4].response,
        agriExpensesUpload: checklist1que && checklist1que[2].subQuestion[5].fields[5].response,
        // Screen 5
        traveloutsideType: checklist1 && checklist1.questions[4].fields[0].response,
        // 6th Screen
        directorType: checklist1 && checklist1.questions[5].fields[0].response,
        // 7th screen
        assetradio: 'Yes',

        totalincomeradio: checklist1 && checklist1.questions[7].subQuestion[5].fields[0].response,
    };

    // screen 3 - Tab 1 - Salary
    const investmentArr = [];

    if (checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[0].subSubQuestions[1].fields.length; i += 3) {
            let investmentArrtemp = {
                investmentDetails: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i].response,
                investmentDetailsCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i].relevanceResponseCRC,
                investmentDetailsCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                investmentAmt: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 1].response,
                investmentAmtCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                investmentAmtCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,
                invAmtUpload: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[1].fields[i + 2].response,
            };
            investmentArr.push(investmentArrtemp);
        }
    } else {
        const investmentArrtemp = {
            investmentDetails: '',
            investmentAmt: '',
            invAmtUpload: '',
        };
        investmentArr.push(investmentArrtemp);
    }
    initialValues.investment = investmentArr;

    const donationArr = [];

    if (checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[0].subSubQuestions[2].fields.length; i += 3) {
            const donationArrtemp = {
                donationDetails: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i].response,
                donationDetailsCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i].relevanceResponseCRC,
                donationDetailsCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i].relevanceRemarksCRC,
                donationAmt: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 1].response,
                donationAmountCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 1].relevanceResponseCRC,
                donationAmountCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 1].relevanceRemarksCRC,
                donationAmtUpload: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[2].fields[i + 2].response,
            };
            donationArr.push(donationArrtemp);
        }
    } else {
        const donationArrtemp = {
            donationDetails: '',
            donationAmt: '',
            donationAmtUpload: '',
        };
        donationArr.push(donationArrtemp);
    }
    initialValues.donation = donationArr;

    let tallyYesArr = [];

    if (checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[2].subSubQuestions[1].fields.length; i += 9) {
            let tallyYesArrtemp = {
                nameFirm: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i].response,
                nameFirmCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i].relevanceResponseCRC,
                nameFirmCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                panNoFirm: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 1].response,
                panNoFirmCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                panNoFirmCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,
                remunRec: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 2].response,
                remunRecCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 2].relevanceResponseCRC,
                remunRecCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 2].relevanceRemarksCRC,
                amtInt: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 3].response,
                amtIntCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 3].relevanceResponseCRC,
                amtIntCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 3].relevanceRemarksCRC,
                shareProfit: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 4].response,
                shareProfitCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 4].relevanceResponseCRC,
                shareProfitCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 4].relevanceRemarksCRC,
                shareProfitRs: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 5].response,
                shareProfitRsCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 5].relevanceResponseCRC,
                shareProfitRsCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 5].relevanceRemarksCRC,
                firmAudit: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 6].response,
                firmAuditCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 6].relevanceResponseCRC,
                firmAuditCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 6].relevanceRemarksCRC,
                transferPrice: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 7].response,
                transferPriceCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 7].relevanceResponseCRC,
                transferPriceCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 7].relevanceRemarksCRC,
                balance: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 8].response,
                balanceCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 8].relevanceResponseCRC,
                balanceCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[1].fields[i + 8].relevanceRemarksCRC,
            };
            tallyYesArr.push(tallyYesArrtemp);
        }
    } else {
        let tallyYesArrtemp = {
            nameFirm: '',
            panNoFirm: '',
            remunRec: '',
            amtInt: '',
            shareProfit: '',
            shareProfitRs: '',
            firmAudit: '',
            transferPrice: '',
            balance: '',
        };
        tallyYesArr.push(tallyYesArrtemp);
    }
    initialValues.tallyYes = tallyYesArr;

    // screen 3 - Tab 2 -House prop

    let housepropertyArr = [];
    if (checklist1que && checklist1que[2].subQuestion[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[1].fields.length; i += 14) {
            let coownerArr = [];
            let housePropertyIndex = 0;
            let housepropertyArrtemp = {
                houseAddress: checklist1que[2].subQuestion[1].fields[i].response,
                houseAddressCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i].relevanceResponseCRC,
                houseAddressCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i].relevanceRemarksCRC,

                houseStatusType: checklist1que[2].subQuestion[1].fields[i + 1].response || 'letout',
                houseStatusTypeCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 1].relevanceResponseCRC,
                houseStatusTypeCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 1].relevanceRemarks,

                rent: checklist1que[2].subQuestion[1].fields[i + 2].response,
                rentCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 2].relevanceResponseCRC,
                rentCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 2].relevanceRemarksCRC,

                propTax: checklist1que[2].subQuestion[1].fields[i + 3].response,
                propTaxCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 3].relevanceResponseCRC,
                propTaxCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 3].relevanceRemarksCRC,

                tenantName: checklist1que[2].subQuestion[1].fields[i + 4].response,
                tenantNameCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 4].relevanceResponseCRC,
                tenantNameCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 4].relevanceRemarksCRC,

                pan: checklist1que[2].subQuestion[1].fields[i + 5].response,
                panCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 5].relevanceResponseCRC,
                panCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 5].relevanceRemarksCRC,

                housepurposeType: checklist1que[2].subQuestion[1].fields[i + 6].response || 'commercial',
                housepurposeTypeCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 6].relevanceResponseCRC,
                housepurposeTypeCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 6].relevanceRemarksCRC,

                propertyCoOwnedType: checklist1que[2].subQuestion[1].fields[i + 11].response || 'coownerYes',
                propertyCoOwnedTypeCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 11].relevanceResponseCRC,
                propertyCoOwnedTypeCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 11].relevanceRemarksCRC,

                rentUpload: checklist1que[2].subQuestion[1].fields[i + 7].response,
                // uploadCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[1].fields[i + 7].relevanceResponseCRC,
                // uploadCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[1].fields[i + 7].relevanceRemarksCRC,

                propertyUpload: checklist1que[2].subQuestion[1].fields[i + 9].response,
                haveyoutakenanyhousingloanType: checklist1que[2].subQuestion[1].fields[i + 10].response || 'housingLoanyes',
                haveyoutakenanyhousingloanTypeCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 10].relevanceResponseCRC,
                haveyoutakenanyhousingloanTypeCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 10].relevanceRemarksCRC,

                TDSdeductedinrentType: checklist1que[2].subQuestion[1].fields[i + 8].response || 'tdsyes',
                TDSdeductedinrentTypeCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 8].relevanceResponseCRC,
                TDSdeductedinrentTypeCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[1].fields[i + 8].relevanceRemarksCRC,

                // loanUpload: checklist1que && checklist1que[2] && checklist1que[2].subQuestion[1] && checklist1que[2].subQuestion[1].fields[i + 12] && checklist1que[2].subQuestion[1].fields[i + 12].response,
                // TDSUpload: checklist1que && checklist1que[2] && checklist1que[2].subQuestion[1] && checklist1que[2].subQuestion[1].fields[i + 13] && checklist1que[2].subQuestion[1].fields[i + 13].response,

                loanUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 12] &&
                    checklist1que[2].subQuestion[1].fields[i + 12].response,
                loanUploadCRCrelevenceResponse:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 12] &&
                    checklist1que[2].subQuestion[1].fields[i + 12].relevanceResponseCRC,
                loanUploadCRCrelevenceRemarks:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 12] &&
                    checklist1que[2].subQuestion[1].fields[i + 12].relevanceRemarksCRC,

                TDSUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 13] &&
                    checklist1que[2].subQuestion[1].fields[i + 13].response,
                TDSUploadCRCrelevenceResponse:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 13] &&
                    checklist1que[2].subQuestion[1].fields[i + 13].relevanceResponseCRC,
                TDSUploadCRCrelevenceRemarks:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[1] &&
                    checklist1que[2].subQuestion[1].fields[i + 13] &&
                    checklist1que[2].subQuestion[1].fields[i + 13].relevanceRemarksCRC,

                coowner: [],
            };

            if (checklist1que[2].subQuestion[1].subSubQuestions.length > 0) {
                let coOwnerList = [];
                for (let j = 0; j < checklist1que[2].subQuestion[1].subSubQuestions.length; j += 3) {
                    if (checklist1que[2].subQuestion[1].subSubQuestions[j].sectionText.split('-').pop() == housepropertyArr.length) {
                        let coOwner = {
                            coownerName: checklist1que[2].subQuestion[1].subSubQuestions[j].response,
                            coownerNameCRCrelevenceResponse:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j].relevanceResponseCRC,
                            coownerNameCRCrelevenceRemarks:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j].relevanceRemarksCRC,

                            coownerPan: checklist1que[2].subQuestion[1].subSubQuestions[j + 1].response,
                            coownerPanCRCrelevenceResponse:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 1].relevanceResponseCRC,
                            coownerPanCRCrelevenceRemarks:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 1].relevanceRemarksCRC,

                            share: checklist1que[2].subQuestion[1].subSubQuestions[j + 2].response,
                            shareCRCrelevenceResponse:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 2].relevanceResponseCRC,
                            shareCRCrelevenceRemarks:
                                checklist1que && checklist1que[2].subQuestion[1].subSubQuestions[j + 2].relevanceRemarksCRC,
                        };

                        coOwnerList.push(coOwner);
                    }
                }
                housepropertyArrtemp.coowner = coOwnerList;
            }
            housepropertyArr.push(housepropertyArrtemp);
        }
        // setHouseCount(housepropertyArr.length)
    } else {
        let housepropertyArrtemp = {
            houseAddress: '',
            houseStatusType: '',
            rent: '',
            propTax: '',
            tenantName: '',
            pan: '',
            housepurposeType: '',
            propertyCoOwnedType: '',
            coowner: [
                {
                    coownerName: '',
                    coownerPan: '',
                    share: '',
                },
            ],
            haveyoutakenanyhousingloanType: '',
            rentUpload: '',
            TDSdeductedinrentType: '',
            propertyUpload: '',
            loanUpload: '',
            TDSUpload: '',
        };
        housepropertyArr.push(housepropertyArrtemp);
    }
    initialValues.houseproperty = housepropertyArr;

    // screen 3 - Tab 4 -capital gain
    let capitalgainArr = [];

    if (checklist1que && checklist1que[2].subQuestion[3].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[3].fields.length; i += 2) {
            let capitalgainArrtemp = {
                natureAssets: checklist1que && checklist1que[2].subQuestion[3].fields[i].response,
                balanceCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[3].fields[i].relevanceResponseCRC,
                balanceCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[3].fields[i].relevanceRemarksCRC,
                natureAssetsUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[3] &&
                    checklist1que[2].subQuestion[3].fields[i + 1] &&
                    checklist1que[2].subQuestion[3].fields[i + 1].response,
            };
            capitalgainArr.push(capitalgainArrtemp);
        }
    } else {
        let capitalgainArrtemp = {
            natureAssets: '',
            natureAssetsUpload: '',
        };
        capitalgainArr.push(capitalgainArrtemp);
    }

    initialValues.capitalgain = capitalgainArr;

    // scrren 3 - Tab 5 - agriculture
    const agricultureArr = [];
    if (checklist1que && checklist1que[2].subQuestion[5].fields.length > 1) {
        //console.log('Field Length', checklist1que[4].fields.length);
        for (let i = 0; i < checklist1que[2].subQuestion[5].fields.length; i += 6) {
            const agricultureArrtemp = {
                agricultureName: (checklist1que && checklist1que[2].subQuestion[5].fields[i].response) || '',
                agricultureNameCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i].relevanceResponseCRC,
                agricultureNameCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i].relevanceRemarksCRC,
                agriAmount: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 1].response) || '',
                agriAmountCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i + 1].relevanceResponseCRC,
                agriAmountCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i + 1].relevanceRemarksCRC,
                agriReceipt: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 2].response) || '',
                agriReceiptCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i + 2].relevanceResponseCRC,
                agriReceiptCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i + 2].relevanceRemarksCRC,
                agriExpenses: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 3].response) || '',
                agriExpensesCRCrelevenceResponse: checklist1que && checklist1que[2].subQuestion[5].fields[i + 3].relevanceResponseCRC,
                agriExpensesCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[5].fields[i + 3].relevanceRemarksCRC,
                agriReceiptUpload: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 4].response) || '',
                agriExpensesUpload: (checklist1que && checklist1que[2].subQuestion[5].fields[i + 5].response) || '',
            };
            agricultureArr.push(agricultureArrtemp);
        }
    } else {
        const agricultureArrtemp = {
            agricultureName: '',
            agriAmount: '',
            agriReceipt: '',
            agriExpenses: '',
            agriReceiptUpload: '',
            agriExpensesUpload: '',
        };
        agricultureArr.push(agricultureArrtemp);
    }
    initialValues.agriculture = agricultureArr;

    // screen 3 -Tab 5 - other source
    let dividentArr = [];
    if (checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[4].subSubQuestions[0].fields.length; i += 3) {
            let dividenttempArr = {
                divPayer: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i].response,
                divPayerCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i].relevanceResponseCRC,
                divPayerCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i].relevanceRemarksCRC,
                divAmount: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 1].response,
                divAmountCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 1].relevanceResponseCRC,
                divAmountCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 1].relevanceRemarksCRC,
                divUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[4] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[0] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 2] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[0].fields[i + 2].response,
            };
            dividentArr.push(dividenttempArr);
        }
    } else {
        let dividenttempArr = {
            divPayer: '',
            divAmount: '',
            divUpload: '',
        };
        dividentArr.push(dividenttempArr);
    }

    initialValues.divident = dividentArr;

    let fdArr = [];
    if (checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[4].subSubQuestions[1].fields.length; i += 3) {
            let fdtempArr = {
                fdPayer: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i].response,
                fdPayerCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i].relevanceResponseCRC,
                fdPayerCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                fdAmount: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 1].response,
                fdAmountCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                fdAmountCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,
                fdUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[4] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[1] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 2] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[1].fields[i + 2].response,
            };
            fdArr.push(fdtempArr);
        }
    } else {
        let fdtempArr = {
            fdPayer: '',
            fdAmount: '',
            fdUpload: '',
        };
        fdArr.push(fdtempArr);
    }

    initialValues.fd = fdArr;

    let othersArr = [];
    if (checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[4].subSubQuestions[2].fields.length; i += 3) {
            let othertempArr = {
                otherPayer: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i].response,
                otherPayerCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i].relevanceResponseCRC,
                otherPayerCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i].relevanceRemarksCRC,
                otherAmount: checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 1].response,
                otherAmountCRCrelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 1].relevanceResponseCRC,
                otherAmountCRCrelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 1].relevanceRemarksCRC,
                otherUpload:
                    checklist1que &&
                    checklist1que[2] &&
                    checklist1que[2].subQuestion[4] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[2] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 2] &&
                    checklist1que[2].subQuestion[4].subSubQuestions[2].fields[i + 2].response,
            };
            othersArr.push(othertempArr);
        }
    } else {
        let othertempArr = {
            otherPayer: '',
            otherAmount: '',
            otherUpload: '',
        };
        othersArr.push(othertempArr);
    }

    initialValues.othersources = othersArr;

    let clientArr10 = [];

    if (checklist1que && checklist1que[6].subQuestion[10].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[10].fields.length; i += 7) {
            let clientArr = {
                country: checklist1que[6].subQuestion[10].fields[i].response,
                country1Relevance: checklist1que[6].subQuestion[10].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que[6].subQuestion[10].fields[i].relevanceRemarksCRC,

                instiName: checklist1que[6].subQuestion[10].fields[i + 1].response,
                instiNameRelevance: checklist1que[6].subQuestion[10].fields[i + 1].relevanceResponseCRC,
                instiNameRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 1].relevanceRemarksCRC,

                instiAddr: checklist1que[6].subQuestion[10].fields[i + 2].response,
                instiAddrRelevance: checklist1que[6].subQuestion[10].fields[i + 2].relevanceResponseCRC,
                instiAddrRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 2].relevanceRemarksCRC,

                zip: checklist1que[6].subQuestion[10].fields[i + 3].response,
                zipRelevance: checklist1que[6].subQuestion[10].fields[i + 3].relevanceResponseCRC,
                zipRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 3].relevanceRemarksCRC,

                date: checklist1que[6].subQuestion[10].fields[i + 4].response,
                dateRelevance: checklist1que[6].subQuestion[10].fields[i + 4].relevanceResponseCRC,
                dateRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 4].relevanceRemarksCRC,

                cashValue: checklist1que[6].subQuestion[10].fields[i + 5].response,
                cashValueRelevance: checklist1que[6].subQuestion[10].fields[i + 5].relevanceResponseCRC,
                cashValueRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 5].relevanceRemarksCRC,

                grossValue: checklist1que[6].subQuestion[10].fields[i + 6].response,
                grossValueRelevance: checklist1que[6].subQuestion[10].fields[i + 6].relevanceResponseCRC,
                grossValueRelevanceRemarks: checklist1que[6].subQuestion[10].fields[i + 6].relevanceRemarksCRC,
            };
            clientArr10.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            instiName: '',
            instiNameRelevance: '',
            instiNameRelevanceRemarks: '',

            instiAddr: '',
            instiAddrRelevance: '',
            instiAddrRelevanceRemarks: '',

            zip: '',
            zipRelevance: '',
            zipRelevanceRemarks: '',

            date: '',
            dateRelevance: '',
            dateRelevanceRemarks: '',

            cashValue: '',
            cashValueRelevance: '',
            cashValueRelevanceRemarks: '',

            grossValue: '',
            grossValueRelevance: '',
            grossValueRelevanceRemarks: '',
        };
        clientArr10.push(clientArr);
    }
    initialValues.client10 = clientArr10;

    let clientArr9 = [];

    if (checklist1que && checklist1que[6].subQuestion[9].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[9].fields.length; i += 10) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[9].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[9].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i].relevanceRemarksCRC,

                entityName: checklist1que && checklist1que[6].subQuestion[9].fields[i + 1].response,
                entityNameRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 1].relevanceResponseCRC,
                entityNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 1].relevanceRemarksCRC,

                entityAddress: checklist1que && checklist1que[6].subQuestion[9].fields[i + 2].response,
                entityAddressRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 2].relevanceResponseCRC,
                entityAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 2].relevanceRemarksCRC,

                zip: checklist1que && checklist1que[6].subQuestion[9].fields[i + 3].response,
                zipRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 3].relevanceResponseCRC,
                zipRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 3].relevanceRemarksCRC,

                entityNature: checklist1que && checklist1que[6].subQuestion[9].fields[i + 4].response,
                entityNatureRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 4].relevanceResponseCRC,
                entityNatureRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 4].relevanceRemarksCRC,

                acquireDate: checklist1que && checklist1que[6].subQuestion[9].fields[i + 5].response,
                acquireDateRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 5].relevanceResponseCRC,
                acquireDateRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 5].relevanceRemarksCRC,

                initialInvest: checklist1que && checklist1que[6].subQuestion[9].fields[i + 6].response,
                initialInvestRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 6].relevanceResponseCRC,
                initialInvestRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 6].relevanceRemarksCRC,

                peakInvest: checklist1que && checklist1que[6].subQuestion[9].fields[i + 7].response,
                peakInvestRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 7].relevanceResponseCRC,
                peakInvestRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 7].relevanceRemarksCRC,

                closingBalance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 8].response,
                closingBalanceRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 8].relevanceResponseCRC,
                closingBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 8].relevanceRemarksCRC,

                grossAmount: checklist1que && checklist1que[6].subQuestion[9].fields[i + 9].response,
                grossAmountRelevance: checklist1que && checklist1que[6].subQuestion[9].fields[i + 9].relevanceResponseCRC,
                grossAmountRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[9].fields[i + 9].relevanceRemarksCRC,
            };
            clientArr9.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            entityName: '',
            entityNameRelevance: '',
            entityNameRelevanceRemarks: '',

            entityAddress: '',
            entityAddressRelevance: '',
            entityAddressRelevanceRemarks: '',

            zip: '',
            zipRelevance: '',
            zipRelevanceRemarks: '',

            entityNature: '',
            entityNatureRelevance: '',
            entityNatureRelevanceRemarks: '',

            acquireDate: '',
            acquireDateRelevance: '',
            acquireDateRelevanceRemarks: '',

            initialInvest: '',
            initialInvestRelevance: '',
            initialInvestRelevanceRemarks: '',

            peakInvest: '',
            peakInvestRelevance: '',
            peakInvestRelevanceRemarks: '',

            closingBalance: '',
            closingBalanceRelevance: '',
            closingBalanceRelevanceRemarks: '',

            grossAmount: '',
            grossAmountRelevance: '',
            grossAmountRelevanceRemarks: '',
        };
        clientArr9.push(clientArr);
    }
    initialValues.client9 = clientArr9;

    let clientArr8 = [];

    if (checklist1que && checklist1que[6].subQuestion[8].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[8].fields.length; i += 10) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[8].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[8].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i].relevanceRemarksCRC,

                institutionName: checklist1que && checklist1que[6].subQuestion[8].fields[i + 1].response,
                institutionNameRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 1].relevanceResponseCRC,
                institutionNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 1].relevanceRemarksCRC,

                institutionAddr: checklist1que && checklist1que[6].subQuestion[8].fields[i + 2].response,
                institutionAddrRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 2].relevanceResponseCRC,
                institutionAddrRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 2].relevanceRemarksCRC,

                zip: checklist1que && checklist1que[6].subQuestion[8].fields[i + 3].response,
                zipRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 3].relevanceResponseCRC,
                zipRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 3].relevanceRemarksCRC,

                accountNumber: checklist1que && checklist1que[6].subQuestion[8].fields[i + 4].response,
                accountNumberRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 4].relevanceResponseCRC,
                accountNumberRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 4].relevanceRemarksCRC,

                status: checklist1que && checklist1que[6].subQuestion[8].fields[i + 5].response,
                statusRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 5].relevanceResponseCRC,
                statusRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 5].relevanceRemarksCRC,

                date: checklist1que && checklist1que[6].subQuestion[8].fields[i + 6].response,
                dateRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 6].relevanceResponseCRC,
                dateRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 6].relevanceRemarksCRC,

                peakBalance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 7].response,
                peakBalanceRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 7].relevanceResponseCRC,
                peakBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 7].relevanceRemarksCRC,

                closingBalance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 8].response,
                closingBalanceRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 8].relevanceResponseCRC,
                closingBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 8].relevanceRemarksCRC,

                grossAmount: checklist1que && checklist1que[6].subQuestion[8].fields[i + 9].response,
                grossAmountRelevance: checklist1que && checklist1que[6].subQuestion[8].fields[i + 9].relevanceResponseCRC,
                grossAmountRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[8].fields[i + 9].relevanceRemarksCRC,
            };
            clientArr8.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            institutionName: '',
            institutionNameRelevance: '',
            institutionNameRelevanceRemarks: '',

            institutionAddr: '',
            institutionAddrRelevance: '',
            institutionAddrRelevanceRemarks: '',

            zip: '',
            zipRelevance: '',
            zipRelevanceRemarks: '',

            accountNumber: '',
            accountNumberRelevance: '',
            accountNumberRelevanceRemarks: '',

            status: '',
            statusRelevance: '',
            statusRelevanceRemarks: '',

            date: '',
            dateRelevance: '',
            dateRelevanceRemarks: '',

            peakBalance: '',
            peakBalanceRelevance: '',
            peakBalanceRelevanceRemarks: '',

            closingBalance: '',
            closingBalanceRelevance: '',
            closingBalanceRelevanceRemarks: '',

            grossAmount: '',
            grossAmountRelevance: '',
            grossAmountRelevanceRemarks: '',
        };
        clientArr8.push(clientArr);
    }
    initialValues.client8 = clientArr8;

    let clientArr7 = [];

    if (checklist1que && checklist1que[6].subQuestion[7].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[7].fields.length; i += 9) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[7].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[7].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i].relevanceRemarksCRC,

                institutionName: checklist1que && checklist1que[6].subQuestion[7].fields[i + 1].response,
                institutionNameRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 1].relevanceResponseCRC,
                institutionNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 1].relevanceRemarksCRC,

                institutionAddr: checklist1que && checklist1que[6].subQuestion[7].fields[i + 2].response,
                institutionAddrRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 2].relevanceResponseCRC,
                institutionAddrRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 2].relevanceRemarksCRC,

                zip: checklist1que && checklist1que[6].subQuestion[7].fields[i + 3].response,
                zipRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 3].relevanceResponseCRC,
                zipRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 3].relevanceRemarksCRC,

                accountNumber: checklist1que && checklist1que[6].subQuestion[7].fields[i + 4].response,
                accountNumberRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 4].relevanceResponseCRC,
                accountNumberRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 4].relevanceRemarksCRC,

                status: checklist1que && checklist1que[6].subQuestion[7].fields[i + 5].response,
                statusRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 5].relevanceResponseCRC,
                statusRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 5].relevanceRemarksCRC,

                date: checklist1que && checklist1que[6].subQuestion[7].fields[i + 6].response,
                dateRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 6].relevanceResponseCRC,
                dateRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 6].relevanceRemarksCRC,

                peakBalance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 7].response,
                peakBalanceRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 7].relevanceResponseCRC,
                peakBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 7].relevanceRemarksCRC,

                closingBalance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 8].response,
                closingBalanceRelevance: checklist1que && checklist1que[6].subQuestion[7].fields[i + 8].relevanceResponseCRC,
                closingBalanceRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[7].fields[i + 8].relevanceRemarksCRC,
            };
            clientArr7.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            institutionName: '',
            institutionNameRelevance: '',
            institutionNameRelevanceRemarks: '',

            institutionAddr: '',
            institutionAddrRelevance: '',
            institutionAddrRelevanceRemarks: '',

            zip: '',
            zipRelevance: '',
            zipRelevanceRemarks: '',

            accountNumber: '',
            accountNumberRelevance: '',
            accountNumberRelevanceRemarks: '',

            status: '',
            statusRelevance: '',
            statusRelevanceRemarks: '',

            date: '',
            dateRelevance: '',
            dateRelevanceRemarks: '',

            peakBalance: '',
            peakBalanceRelevance: '',
            peakBalanceRelevanceRemarks: '',

            closingBalance: '',
            closingBalanceRelevance: '',
            closingBalanceRelevanceRemarks: '',
        };
        clientArr7.push(clientArr);
    }
    initialValues.client7 = clientArr7;

    let clientArr6 = [];

    if (checklist1que && checklist1que[6].subQuestion[6].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[6].fields.length; i += 5) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[6].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[6].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i].relevanceRemarksCRC,

                personName: checklist1que && checklist1que[6].subQuestion[6].fields[i + 1].response,
                personNameRelevance: checklist1que && checklist1que[6].subQuestion[6].fields[i + 1].relevanceResponseCRC,
                personNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i + 1].relevanceRemarksCRC,

                personAddr: checklist1que && checklist1que[6].subQuestion[6].fields[i + 2].response,
                personAddrRelevance: checklist1que && checklist1que[6].subQuestion[6].fields[i + 2].relevanceResponseCRC,
                personAddrRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i + 2].relevanceRemarksCRC,

                derivedIncome: checklist1que && checklist1que[6].subQuestion[6].fields[i + 3].response,
                derivedIncomeRelevance: checklist1que && checklist1que[6].subQuestion[6].fields[i + 3].relevanceResponseCRC,
                derivedIncomeRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i + 3].relevanceRemarksCRC,

                incomeNature: checklist1que && checklist1que[6].subQuestion[6].fields[i + 4].response,
                incomeNatureRelevance: checklist1que && checklist1que[6].subQuestion[6].fields[i + 4].relevanceResponseCRC,
                incomeNatureRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[6].fields[i + 4].relevanceRemarksCRC,
            };
            clientArr6.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            personName: '',
            personNameRelevance: '',
            personNameRelevanceRemarks: '',

            personAddr: '',
            personAddrRelevance: '',
            personAddrRelevanceRemarks: '',

            derivedIncome: '',
            derivedIncomeRelevance: '',
            derivedIncomeRelevanceRemarks: '',

            incomeNature: '',
            incomeNatureRelevance: '',
            incomeNatureRelevanceRemarks: '',
        };
        clientArr6.push(clientArr);
    }
    initialValues.client6 = clientArr6;

    let clientArr5 = [];

    if (checklist1que && checklist1que[6].subQuestion[5].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[5].fields.length; i += 9) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[5].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[5].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i].relevanceRemarksCRC,

                trustName: checklist1que && checklist1que[6].subQuestion[5].fields[i + 1].response,
                trustNameRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 1].relevanceResponseCRC,
                trustNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 1].relevanceRemarksCRC,

                trustAddress: checklist1que && checklist1que[6].subQuestion[5].fields[i + 2].response,
                trustAddressRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 2].relevanceResponseCRC,
                trustAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 2].relevanceRemarksCRC,

                trusteeName: checklist1que && checklist1que[6].subQuestion[5].fields[i + 3].response,
                trusteeNameRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 3].relevanceResponseCRC,
                trusteeNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 3].relevanceRemarksCRC,

                trusteeAddress: checklist1que && checklist1que[6].subQuestion[5].fields[i + 4].response,
                trusteeAddressRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 4].relevanceResponseCRC,
                trusteeAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 4].relevanceRemarksCRC,

                settlorAddress: checklist1que && checklist1que[6].subQuestion[5].fields[i + 5].response,
                settlorAddressRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 5].relevanceResponseCRC,
                settlorAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 5].relevanceRemarksCRC,

                settlorName: checklist1que && checklist1que[6].subQuestion[5].fields[i + 6].response,
                settlorNameRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 6].relevanceResponseCRC,
                settlorNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 6].relevanceRemarksCRC,

                benfName: checklist1que && checklist1que[6].subQuestion[5].fields[i + 7].response,
                benfNameRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 7].relevanceResponseCRC,
                benfNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 7].relevanceRemarksCRC,

                benfAddress: checklist1que && checklist1que[6].subQuestion[5].fields[i + 8].response,
                benfAddressRelevance: checklist1que && checklist1que[6].subQuestion[5].fields[i + 8].relevanceResponseCRC,
                benfAddressRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[5].fields[i + 8].relevanceRemarksCRC,
            };
            clientArr5.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            trustName: '',
            trustNameRelevance: '',
            trustNameRelevanceRemarks: '',

            trustAddress: '',
            trustAddressRelevance: '',
            trustAddressRelevanceRemarks: '',

            trusteeName: '',
            trusteeNameRelevance: '',
            trusteeNameRelevanceRemarks: '',

            trusteeAddress: '',
            trusteeAddressRelevance: '',
            trusteeAddressRelevanceRemarks: '',

            settlorAddress: '',
            settlorAddressRelevance: '',
            settlorAddressRelevanceRemarks: '',

            settlorName: '',
            settlorNameRelevance: '',
            settlorNameRelevanceRemarks: '',

            benfName: '',
            benfNameRelevance: '',
            benfNameRelevanceRemarks: '',

            benfAddress: '',
            benfAddressRelevance: '',
            benfAddressRelevanceRemarks: '',
        };
        clientArr5.push(clientArr);
    }
    initialValues.client5 = clientArr5;

    let clientArr4 = [];

    if (checklist1que && checklist1que[6].subQuestion[4].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[4].fields.length; i += 5) {
            let clientArr = {
                institutionName: checklist1que && checklist1que[6].subQuestion[4].fields[i].response,
                institutionNameRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i].relevanceResponseCRC,
                institutionNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i].relevanceRemarksCRC,

                institutionAddr: checklist1que && checklist1que[6].subQuestion[4].fields[i + 1].response,
                institutionAddrRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i + 1].relevanceResponseCRC,
                institutionAddrRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i + 1].relevanceRemarksCRC,

                accholderName: checklist1que && checklist1que[6].subQuestion[4].fields[i + 2].response,
                accholderNameRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i + 2].relevanceResponseCRC,
                accholderNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i + 2].relevanceRemarksCRC,

                accountNumber: checklist1que && checklist1que[6].subQuestion[4].fields[i + 3].response,
                accountNumberRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i + 3].relevanceResponseCRC,
                accountNumberRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i + 3].relevanceRemarksCRC,

                peakBal: checklist1que && checklist1que[6].subQuestion[4].fields[i + 4].response,
                peakBalRelevance: checklist1que && checklist1que[6].subQuestion[4].fields[i + 4].relevanceResponseCRC,
                peakBalRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[4].fields[i + 4].relevanceRemarksCRC,
            };
            clientArr4.push(clientArr);
        }
    } else {
        let clientArr = {
            institutionName: '',
            institutionNameRelevance: '',
            institutionNameRelevanceRemarks: '',

            institutionAddr: '',
            institutionAddrRelevance: '',
            institutionAddrRelevanceRemarks: '',

            accholderName: '',
            accholderNameRelevance: '',
            accholderNameRelevanceRemarks: '',

            accountNumber: '',
            accountNumberRelevance: '',
            accountNumberRelevanceRemarks: '',

            peakBal: '',
            peakBalRelevance: '',
            peakBalRelevanceRemarks: '',
        };
        clientArr4.push(clientArr);
    }
    initialValues.client4 = clientArr4;

    let clientArr3 = [];

    if (checklist1que && checklist1que[6].subQuestion[3].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[3].fields.length; i += 7) {
            let clientArr = {
                country: checklist1que && checklist1que[6].subQuestion[3].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[3].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i].relevanceRemarksCRC,

                assetName: checklist1que && checklist1que[6].subQuestion[3].fields[i + 1].response,
                assetNameRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 1].relevanceResponseCRC,
                assetNameRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 1].relevanceRemarksCRC,

                ownership: checklist1que && checklist1que[6].subQuestion[3].fields[i + 2].response,
                ownershipRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 2].relevanceResponseCRC,
                ownershipRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 2].relevanceRemarksCRC,

                acqisitionDate: checklist1que && checklist1que[6].subQuestion[3].fields[i + 3].response,
                acqisitionDateRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 3].relevanceResponseCRC,
                acqisitionDateRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 3].relevanceRemarksCRC,

                totInvestment: checklist1que && checklist1que[6].subQuestion[3].fields[i + 4].response,
                totInvestmentRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 4].relevanceResponseCRC,
                totInvestmentRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 4].relevanceRemarksCRC,

                assetIncome: checklist1que && checklist1que[6].subQuestion[3].fields[i + 5].response,
                assetIncomeRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 5].relevanceResponseCRC,
                assetIncomeRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 5].relevanceRemarksCRC,

                incomeNature: checklist1que && checklist1que[6].subQuestion[3].fields[i + 6].response,
                incomeNatureRelevance: checklist1que && checklist1que[6].subQuestion[3].fields[i + 6].relevanceResponseCRC,
                incomeNatureRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[3].fields[i + 6].relevanceRemarksCRC,
            };
            clientArr3.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            assetName: '',
            assetNameRelevance: '',
            assetNameRelevanceRemarks: '',

            ownership: '',
            ownershipRelevance: '',
            ownershipRelevanceRemarks: '',

            acqisitionDate: '',
            acqisitionDateRelevance: '',
            acqisitionDateRelevanceRemarks: '',

            totInvestment: '',
            totInvestmentRelevance: '',
            totInvestmentRelevanceRemarks: '',

            assetIncome: '',
            assetIncomeRelevance: '',
            assetIncomeRelevanceRemarks: '',

            incomeNature: '',
            incomeNatureRelevance: '',
            incomeNatureRelevanceRemarks: '',
        };
        clientArr3.push(clientArr);
    }
    initialValues.client3 = clientArr3;

    let clientArr2 = [];

    if (checklist1que && checklist1que[6].subQuestion[2].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[2].fields.length; i += 7) {
            let clientArr = {
                country: checklist1que[6].subQuestion[2].fields[i].response,
                country1Relevance: checklist1que[6].subQuestion[2].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que[6].subQuestion[2].fields[i].relevanceRemarksCRC,

                propAddress: checklist1que[6].subQuestion[2].fields[i + 1].response,
                propAddressRelevance: checklist1que[6].subQuestion[2].fields[i + 1].relevanceResponseCRC,
                propAddressRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 1].relevanceRemarksCRC,

                ownership: checklist1que[6].subQuestion[2].fields[i + 2].response,
                ownershipRelevance: checklist1que[6].subQuestion[2].fields[i + 2].relevanceResponseCRC,
                ownershipRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 2].relevanceRemarksCRC,

                acqisitionDate: checklist1que[6].subQuestion[2].fields[i + 3].response,
                acqisitionDateRelevance: checklist1que[6].subQuestion[2].fields[i + 3].relevanceResponseCRC,
                acqisitionDateRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 3].relevanceRemarksCRC,

                totInvestment: checklist1que[6].subQuestion[2].fields[i + 4].response,
                totInvestmentRelevance: checklist1que[6].subQuestion[2].fields[i + 4].relevanceResponseCRC,
                totInvestmentRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 4].relevanceRemarksCRC,

                propIncome: checklist1que[6].subQuestion[2].fields[i + 5].response,
                propIncomeRelevance: checklist1que[6].subQuestion[2].fields[i + 5].relevanceResponseCRC,
                propIncomeRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 5].relevanceRemarksCRC,

                incomeNature: checklist1que[6].subQuestion[2].fields[i + 6].response,
                incomeNatureRelevance: checklist1que[6].subQuestion[2].fields[i + 6].relevanceResponseCRC,
                incomeNatureRelevanceRemarks: checklist1que[6].subQuestion[2].fields[i + 6].relevanceRemarksCRC,
            };
            clientArr2.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            propAddress: '',
            propAddressRelevance: '',
            propAddressRelevanceRemarks: '',

            ownership: '',
            ownershipRelevance: '',
            ownershipRelevanceRemarks: '',

            acqisitionDate: '',
            acqisitionDateRelevance: '',
            acqisitionDateRelevanceRemarks: '',

            totInvestment: '',
            totInvestmentRelevance: '',
            totInvestmentRelevanceRemarks: '',

            propIncome: '',
            propIncomeRelevance: '',
            propIncomeRelevanceRemarks: '',

            incomeNature: '',
            incomeNatureRelevance: '',
            incomeNatureRelevanceRemarks: '',
        };
        clientArr2.push(clientArr);
    }
    initialValues.client2 = clientArr2;

    let clientArr1 = [];

    if (checklist1que && checklist1que[6].subQuestion[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[1].fields.length; i += 9) {
            let clientArr = {
                country: checklist1que[6].subQuestion[1].fields[i].response,
                country1Relevance: checklist1que[6].subQuestion[1].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i].relevanceRemarksCRC,

                entityNature: checklist1que[6].subQuestion[1].fields[i + 1].response,
                entityNature1Relevance: checklist1que[6].subQuestion[1].fields[i + 1].relevanceResponseCRC,
                entityNature1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 1].relevanceRemarksCRC,

                entityName: checklist1que[6].subQuestion[1].fields[i + 2].response,
                entityName1Relevance: checklist1que[6].subQuestion[1].fields[i + 2].relevanceResponseCRC,
                entityName1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 2].relevanceRemarksCRC,

                entityAddress: checklist1que[6].subQuestion[1].fields[i + 3].response,
                entityAddress1Relevance: checklist1que[6].subQuestion[1].fields[i + 3].relevanceResponseCRC,
                entityAddress1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 3].relevanceRemarksCRC,

                interestNature: checklist1que[6].subQuestion[1].fields[i + 4].response,
                interestNature1Relevance: checklist1que[6].subQuestion[1].fields[i + 4].relevanceResponseCRC,
                interestNature1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 4].relevanceRemarksCRC,

                date: checklist1que[6].subQuestion[1].fields[i + 5].response,
                date1Relevance: checklist1que[6].subQuestion[1].fields[i + 5].relevanceResponseCRC,
                date1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 5].relevanceRemarksCRC,

                totInvestment: checklist1que[6].subQuestion[1].fields[i + 6].response,
                totInvestment1Relevance: checklist1que[6].subQuestion[1].fields[i + 6].relevanceResponseCRC,
                totInvestment1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 6].relevanceRemarksCRC,

                interestIncome: checklist1que[6].subQuestion[1].fields[i + 7].response,
                interstIncome1Relevance: checklist1que[6].subQuestion[1].fields[i + 7].relevanceResponseCRC,
                interstIncome1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 7].relevanceRemarksCRC,

                incomeNature: checklist1que[6].subQuestion[1].fields[i + 8].response,
                incomeNature1Relevance: checklist1que[6].subQuestion[1].fields[i + 8].relevanceResponseCRC,
                incomeNature1RelevanceRemarks: checklist1que[6].subQuestion[1].fields[i + 8].relevanceRemarksCRC,
            };
            clientArr1.push(clientArr);
        }
    } else {
        let clientArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            entityNature: '',
            entityNature1Relevance: '',
            entityNature1RelevanceRemarks: '',

            entityName: '',
            entityName1Relevance: '',
            entityName1RelevanceRemarks: '',

            entityAddress: '',
            entityAddress1Relevance: '',
            entityAddress1RelevanceRemarks: '',

            interestNature: '',
            interestNature1Relevance: '',
            interestNature1RelevanceRemarks: '',

            date: '',
            date1Relevance: '',
            date1RelevanceRemarks: '',

            totInvestment: '',
            totInvestment1Relevance: '',
            totInvestment1RelevanceRemarks: '',

            interestIncome: '',
            interstIncome1Relevance: '',
            interstIncome1RelevanceRemarks: '',

            incomeNature: '',
            incomeNature1Relevance: '',
            incomeNature1RelevanceRemarks: '',
        };
        clientArr1.push(clientArr);
    }

    initialValues.client1 = clientArr1;

    let assetHomeArr1 = [];
    // Screen 7 -assetHome
    if (checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[0].subSubQuestions[0].fields.length; i += 9) {
            let assetHomeArr = {
                country: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i].response,
                country1Relevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i].relevanceResponseCRC,
                country1RelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i].relevanceRemarksCRC,

                tpin: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 1].response,
                tpinRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 1].relevanceResponseCRC,
                tpinRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 1].relevanceRemarksCRC,

                salA: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 2].response,
                salARelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 2].relevanceResponseCRC,
                salARelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 2].relevanceRemarksCRC,

                salB: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 3].response,
                salBRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 3].relevanceResponseCRC,
                salBRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 3].relevanceRemarksCRC,

                salC: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 4].response,
                salCRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 4].relevanceResponseCRC,
                salCRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 4].relevanceRemarksCRC,

                salD: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 5].response,
                salDRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 5].relevanceResponseCRC,
                salDRelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 5].relevanceRemarksCRC,

                salE: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 6].response,
                salERelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 6].relevanceResponseCRC,
                salERelevanceRemarks: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 6].relevanceRemarksCRC,

                srcNature: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 7].response,
                srcNatureRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 7].relevanceResponseCRC,
                srcNatureRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 7].relevanceRemarksCRC,

                totIncome: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 8].response,
                totIncomeRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 8].relevanceResponseCRC,
                totIncomeRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[0].fields[i + 8].relevanceRemarksCRC,
            };
            assetHomeArr1.push(assetHomeArr);
        }
    } else {
        let assetHomeArr = {
            country: '',
            country1Relevance: '',
            country1RelevanceRemarks: '',

            tpin: '',
            tpinRelevance: '',
            tpinRelevanceRemarks: '',

            salA: '',
            salARelevance: '',
            salARelevanceRemarks: '',

            salB: '',
            salBRelevance: '',
            salBRelevanceRemarks: '',

            salC: '',
            salCRelevance: '',
            salCRelevanceRemarks: '',

            salD: '',
            salDRelevance: '',
            salDRelevanceRemarks: '',

            salE: '',
            salERelevance: '',
            salERelevanceRemarks: '',

            srcNature: '',
            srcNatureRelevance: '',
            srcNatureRelevanceRemarks: '',

            totIncome: '',
            totIncomeRelevance: '',
            totIncomeRelevanceRemarks: '',
        };
        assetHomeArr1.push(assetHomeArr);
    }
    initialValues.assetHome = assetHomeArr1;

    let assetNatureArr1 = [];
    // Screen 7 -assetNature
    if (checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[6].subQuestion[0].subSubQuestions[1].fields.length; i += 3) {
            let assetNatureArr = {
                incomeNature: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i].response,
                incomeNatureRelevance: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i].relevanceResponseCRC,
                incomeNatureRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i].relevanceRemarksCRC,

                foreignAmount: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 1].response,
                foreignAmountRelevance:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                foreignAmountRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,

                foreignTaxes: checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 2].response,
                foreignTaxesRelevance:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 2].relevanceResponseCRC,
                foreignTaxesRelevanceRemarks:
                    checklist1que && checklist1que[6].subQuestion[0].subSubQuestions[1].fields[i + 2].relevanceRemarksCRC,
            };
            assetNatureArr1.push(assetNatureArr);
        }
    } else {
        let assetNatureArr = {
            incomeNature: '',
            incomeNatureRelevance: '',
            incomeNatureRelevanceRemarks: '',

            foreignAmount: '',
            foreignAmountRelevance: '',
            foreignAmountRelevanceRemarks: '',

            foreignTaxes: '',
            foreignTaxesRelevance: '',
            foreignTaxesRelevanceRemarks: '',
        };
        assetNatureArr1.push(assetNatureArr);
    }
    initialValues.assetNature = assetNatureArr1;

    let labelEdataArr = [];

    if (checklist1que && checklist1que[7].subQuestion[4].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[4].fields.length; i += 2) {
            let labelEdataArr1 = {
                particular: checklist1que && checklist1que[7].subQuestion[4].fields[i].response,
                particularRelevance: checklist1que && checklist1que[7].subQuestion[4].fields[i].relevanceResponseCRC,
                particularRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[4].fields[i].relevanceRemarksCRC,

                amount: checklist1que && checklist1que[7].subQuestion[4].fields[i + 1].response,
                amountERelevance: checklist1que && checklist1que[7].subQuestion[4].fields[i + 1].relevanceResponseCRC,
                amountERelevanceRemarks: checklist1que && checklist1que[7].subQuestion[4].fields[i + 1].relevanceRemarksCRC,
            };
            labelEdataArr.push(labelEdataArr1);
        }
    } else {
        let labelEdataArr1 = {
            particular: '',
            particularRelevance: '',
            particularRelevanceRemarks: '',

            amount: '',
            amountERelevance: '',
            amountERelevanceRemarks: '',
        };
        labelEdataArr.push(labelEdataArr1);
    }
    initialValues.labelEdata = labelEdataArr;

    const addremarks = [];
    const addremarksL2Checklist = [];

    if (checklist && checklist.additionalQuestion && checklist.additionalQuestion !== null)
        for (let i = 0; i < checklist.additionalQuestion.length; i++) {
            const additionalQuestionData = {
                questionId: checklist.additionalQuestion[i].questionId || '',

                questionText: checklist.additionalQuestion[i].questionText || '',
                response:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].response
                        : '',
                relevanceResponseCRC:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].relevanceResponseCRC
                        : '',
                relevanceRemarksCRC:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].relevanceRemarksCRC
                        : '',
            };
            addremarks.push(additionalQuestionData);
        }

    if (checklist1que && checklist1que[8].subQuestion[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[8].subQuestion[0].fields.length; i++) {
            const additionalQuestionData = {
                questionId:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].relevanceRemarksAM
                        : '',

                questionText:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].relevanceResponseAM
                        : '',
                response:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].response
                        : '',
                relevanceResponseCRC:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].relevanceResponseCRC
                        : '',
                relevanceRemarksCRC:
                    checklist1que && checklist1que[8].subQuestion[0].fields.length > 0
                        ? checklist1que && checklist1que[8].subQuestion[0].fields[i].relevanceRemarksCRC
                        : '',
            };
            addremarksL2Checklist.push(additionalQuestionData);
        }
    }

    initialValues.remarks = statusIDValue === 2 ? addremarks : addremarksL2Checklist;

    let labelDdataArr = [];

    if (checklist1que && checklist1que[7].subQuestion[3].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[3].fields.length; i += 3) {
            let labelDdataArr1 = {
                name: checklist1que && checklist1que[7].subQuestion[3].fields[i].response,
                nameDRelevance: checklist1que && checklist1que[7].subQuestion[3].fields[i].relevanceResponseCRC,
                nameDRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[3].fields[i].relevanceRemarksCRC,

                pan: checklist1que && checklist1que[7].subQuestion[3].fields[i + 1].response,
                panDRelevance: checklist1que && checklist1que[7].subQuestion[3].fields[i + 1].relevanceResponseCRC,
                panDRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[3].fields[i + 1].relevanceRemarksCRC,

                value: checklist1que && checklist1que[7].subQuestion[3].fields[i + 2].response,
                valueDRelevance: checklist1que && checklist1que[7].subQuestion[3].fields[i + 2].relevanceResponseCRC,
                valueDRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[3].fields[i + 2].relevanceRemarksCRC,
            };
            labelDdataArr.push(labelDdataArr1);
        }
    } else {
        let labelDdataArr1 = {
            name: '',
            nameDRelevance: '',
            nameDRelevanceRemarks: '',

            pan: '',
            panDRelevance: '',
            panDRelevanceRemarks: '',

            value: '',
            valueDRelevance: '',
            valueDRelevanceRemarks: '',
        };
        labelDdataArr.push(labelDdataArr1);
    }

    initialValues.labelDdata = labelDdataArr;

    let labelCdataArr = [];
    if (checklist1que && checklist1que[7].subQuestion[2].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[2].fields.length; i += 16) {
            let labelCdataArr1 = {
                name: checklist1que && checklist1que[7].subQuestion[2].fields[i].response,
                nameCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i].relevanceResponseCRC,
                nameCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i].relevanceRemarksCRC,

                pan: checklist1que && checklist1que[7].subQuestion[2].fields[i + 1].response,
                panCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 1].relevanceResponseCRC,
                panCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 1].relevanceRemarksCRC,

                particularShare: checklist1que && checklist1que[7].subQuestion[2].fields[i + 2].response,
                particularShareCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 2].relevanceResponseCRC,
                particularShareCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 2].relevanceRemarksCRC,

                particularCost: checklist1que && checklist1que[7].subQuestion[2].fields[i + 3].response,
                particularCostCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 3].relevanceResponseCRC,
                particularCostCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 3].relevanceRemarksCRC,

                acquiredShare: checklist1que && checklist1que[7].subQuestion[2].fields[i + 4].response,
                acquiredShareCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 4].relevanceResponseCRC,
                acquiredShareCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 4].relevanceRemarksCRC,

                acquiredDate: checklist1que && checklist1que[7].subQuestion[2].fields[i + 5].response,
                acquiredDateCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 5].relevanceResponseCRC,
                acquiredDateCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 5].relevanceRemarksCRC,

                acquiredValue: checklist1que && checklist1que[7].subQuestion[2].fields[i + 6].response,
                acquiredValueCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 6].relevanceResponseCRC,
                acquiredValueCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 6].relevanceRemarksCRC,

                acquiredIssuePrice: checklist1que && checklist1que[7].subQuestion[2].fields[i + 7].response,
                acquiredIPCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 7].relevanceResponseCRC,
                acquiredIPCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 7].relevanceRemarksCRC,

                acquiredPurchasePrice: checklist1que && checklist1que[7].subQuestion[2].fields[i + 8].response,
                acquiredPPCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 8].relevanceResponseCRC,
                acquiredPPCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 8].relevanceRemarksCRC,

                transferredShare: checklist1que && checklist1que[7].subQuestion[2].fields[i + 9].response,
                tsCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 9].relevanceResponseCRC,
                tsCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 9].relevanceRemarksCRC,

                transferredSale: checklist1que && checklist1que[7].subQuestion[2].fields[i + 10].response,
                tsaleCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 10].relevanceResponseCRC,
                tsaleCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 10].relevanceRemarksCRC,

                closingShare: checklist1que && checklist1que[7].subQuestion[2].fields[i + 11].response,
                closingShareCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 11].relevanceResponseCRC,
                closingSharetsaleCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 11].relevanceRemarksCRC,

                closingCost: checklist1que && checklist1que[7].subQuestion[2].fields[i + 12].response,
                closingCostCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 12].relevanceResponseCRC,
                closingCostsaleCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 12].relevanceRemarksCRC,

                closingSale: checklist1que && checklist1que[7].subQuestion[2].fields[i + 13].response,
                closingSaleCRelevance: checklist1que && checklist1que[7].subQuestion[2].fields[i + 13].relevanceResponseCRC,
                closingSaleCRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[2].fields[i + 13].relevanceRemarksCRC,

                noOfShare: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 14].response) || '',
                noOfShareCRelevance: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 14].relevanceResponseCRC) || '',
                noOfShareCRelevanceRemarks: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 14].relevanceRemarksCRC) || '',

                costOfAcquisition: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 15].response) || '',
                costOfAcquisitionCRelevance: (checklist1que && checklist1que[7].subQuestion[2].fields[i + 15].relevanceResponseCRC) || '',
                costOfAcquisitionCRelevanceRemarks:
                    (checklist1que && checklist1que[7].subQuestion[2].fields[i + 15].relevanceRemarksCRC) || '',
            };
            labelCdataArr.push(labelCdataArr1);
        }
    } else {
        let labelCdataArr1 = {
            name: '',
            nameCRelevance: '',
            nameCRelevanceRemarks: '',

            pan: '',
            panCRelevance: '',
            panCRelevanceRemarks: '',

            particularShare: '',
            particularShareCRelevance: '',
            particularShareCRelevanceRemarks: '',

            particularCost: '',
            particularCostCRelevance: '',
            particularCostCRelevanceRemarks: '',

            acquiredShare: '',
            acquiredShareCRelevance: '',
            acquiredShareCRelevanceRemarks: '',

            acquiredDate: '',
            acquiredDateCRelevance: '',
            acquiredDateCRelevanceRemarks: '',

            acquiredValue: '',
            acquiredValueCRelevance: '',
            acquiredValueCRelevanceRemarks: '',

            acquiredIssuePrice: '',
            acquiredIPCRelevance: '',
            acquiredIPCRelevanceRemarks: '',

            acquiredPurchasePrice: '',
            acquiredPPCRelevance: '',
            acquiredPPCRelevanceRemarks: '',

            transferredShare: '',
            tsCRelevance: '',
            tsCRelevanceRemarks: '',

            transferredSale: '',
            tsaleCRelevance: '',
            tsaleCRelevanceRemarks: '',

            closingShare: '',
            closingShareCRelevance: '',
            closingSharetsaleCRelevanceRemarks: '',

            closingCost: '',
            closingCostCRelevance: '',
            closingCostsaleCRelevanceRemarks: '',

            closingSale: '',
            closingSaleCRelevance: '',
            closingSaleCRelevanceRemarks: '',

            noOfShare: '',
            noOfShareCRelevance: '',
            noOfShareCRelevanceRemarks: '',

            costOfAcquisition: '',
            costOfAcquisitionCRelevance: '',
            costOfAcquisitionCRelevanceRemarks: '',
        };
        labelCdataArr.push(labelCdataArr1);
    }
    initialValues.labelCdata = labelCdataArr;

    let labelBdataArr = [];
    if (checklist1que && checklist1que[7].subQuestion[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[1].fields.length; i += 8) {
            let labelBdataArr1 = {
                jewellaryBullions: (checklist1que && checklist1que[7].subQuestion[1].fields[i].response) || '',
                jewellaryBullionsRelevance: (checklist1que && checklist1que[7].subQuestion[1].fields[i].relevanceResponseCRC) || '',
                jewellaryBullionsRelevanceRemarks: (checklist1que && checklist1que[7].subQuestion[1].fields[i].relevanceRemarksCRC) || '',

                archaeologicalCollections: (checklist1que && checklist1que[7].subQuestion[1].fields[i + 1].response) || '',
                archaeologicalCollectionsRelevance:
                    (checklist1que && checklist1que[7].subQuestion[1].fields[i + 1].relevanceResponseCRC) || '',
                archaeologicalCollectionsRelevanceRemarks:
                    (checklist1que && checklist1que[7].subQuestion[1].fields[i + 1].relevanceRemarksCRC) || '',

                vehiclesYatchBoatsAircrafts: (checklist1que && checklist1que[7].subQuestion[1].fields[i + 2].response) || '',
                vehiclesYatchBoatsAircraftsRelevance:
                    (checklist1que && checklist1que[7].subQuestion[1].fields[i + 2].relevanceResponseCRC) || '',
                vehiclesYatchBoatsAircraftsRelevanceRemarks:
                    (checklist1que && checklist1que[7].subQuestion[1].fields[i + 2].relevanceRemarksCRC) || '',

                faAAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 3].response,
                faAAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 3].relevanceResponseCRC,
                faAAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 3].relevanceRemarksCRC,

                faBAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 4].response,
                faBAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 4].relevanceResponseCRC,
                faBAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 4].relevanceRemarksCRC,

                faCAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 5].response,
                faCAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 5].relevanceResponseCRC,
                faCAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 5].relevanceRemarksCRC,

                faDAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 6].response,
                faDAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 6].relevanceResponseCRC,
                faDAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 6].relevanceRemarksCRC,

                faEAmount: checklist1que && checklist1que[7].subQuestion[1].fields[i + 7].response,
                faEAmountRelevance: checklist1que && checklist1que[7].subQuestion[1].fields[i + 7].relevanceResponseCRC,
                faEAmountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[1].fields[i + 7].relevanceRemarksCRC,
            };
            labelBdataArr.push(labelBdataArr1);
        }
    } else {
        let labelBdataArr1 = {
            jewellaryBullions: '',
            jewellaryBullionsRelevance: '',
            jewellaryBullionsRelevanceRemarks: '',
            archaeologicalCollections: '',
            archaeologicalCollectionsRelevance: '',
            archaeologicalCollectionsRelevanceRemarks: '',
            vehiclesYatchBoatsAircrafts: '',
            vehiclesYatchBoatsAircraftsRelevance: '',
            vehiclesYatchBoatsAircraftsRelevanceRemarks: '',
            faAAmount: '',
            faAAmountRelevance: '',
            faAAmountRelevanceRemarks: '',
            faBAmount: '',
            faBAmountRelevance: '',
            faBAmountRelevanceRemarks: '',
            faCAmount: '',
            faCAmountRelevance: '',
            faCAmountRelevanceRemarks: '',
            faDAmount: '',
            faDAmountRelevance: '',
            faDAmountRelevanceRemarks: '',
            faEAmount: '',
            faEAmountRelevance: '',
            faEAmountRelevanceRemarks: '',
        };
        labelBdataArr.push(labelBdataArr1);
    }
    initialValues.labelBdata = labelBdataArr;

    let labelAdataArr = [];
    if (checklist1que && checklist1que[7].subQuestion[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[7].subQuestion[0].fields.length; i += 3) {
            let labelAdataArr1 = {
                description: checklist1que && checklist1que[7].subQuestion[0].fields[i].response,
                descriptionRelevance: checklist1que && checklist1que[7].subQuestion[0].fields[i].relevanceResponseCRC,
                descriptionRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[0].fields[i].relevanceRemarksCRC,

                address: checklist1que && checklist1que[7].subQuestion[0].fields[i + 1].response,
                addressRelevance: checklist1que && checklist1que[7].subQuestion[0].fields[i + 1].relevanceResponseCRC,
                addressRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[0].fields[i + 1].relevanceRemarksCRC,

                amount: checklist1que && checklist1que[7].subQuestion[0].fields[i + 2].response,
                amountRelevance: checklist1que && checklist1que[7].subQuestion[0].fields[i + 2].relevanceResponseCRC,
                amountRelevanceRemarks: checklist1que && checklist1que[7].subQuestion[0].fields[i + 2].relevanceRemarksCRC,
            };
            labelAdataArr.push(labelAdataArr1);
        }
    } else {
        let labelAdataArr1 = {
            description: '',
            descriptionRelevance: '',
            descriptionRelevanceRemarks: '',
            address: '',
            addressRelevance: '',
            addressRelevanceRemarks: '',
            amount: '',
            amountRelevance: '',
            amountRelevanceRemarks: '',
        };
        labelAdataArr.push(labelAdataArr1);
    }
    initialValues.labelAdata = labelAdataArr;

    let directorArr = [];
    if (checklist1que && checklist1que[5].subQuestion[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[5].subQuestion[0].fields.length; i += 4) {
            let directorArr1 = {
                companyName: checklist1que[5].subQuestion[0].fields[i].response,
                companyNameRelevance: checklist1que[5].subQuestion[0].fields[i].relevanceResponseCRC,
                companyNameRelevanceRemarks: checklist1que[5].subQuestion[0].fields[i].relevanceRemarksCRC,

                panCompany: checklist1que[5].subQuestion[0].fields[i + 1].response,
                panCompanyRelevance: checklist1que[5].subQuestion[0].fields[i + 1].relevanceResponseCRC,
                panCompanyRelevanceRemarks: checklist1que[5].subQuestion[0].fields[i + 1].relevanceRemarksCRC,

                shares: checklist1que[5].subQuestion[0].fields[i + 2].response,
                sharesRelevance: checklist1que[5].subQuestion[0].fields[i + 2].relevanceResponseCRC,
                sharesRelevanceRemarks: checklist1que[5].subQuestion[0].fields[i + 2].relevanceRemarksCRC,

                din: checklist1que[5].subQuestion[0].fields[i + 3].response,
                compDinRelevance: checklist1que[5].subQuestion[0].fields[i + 3].relevanceResponseCRC,
                compDinRelevanceRemarks: checklist1que[5].subQuestion[0].fields[i + 3].relevanceRemarksCRC,
            };
            directorArr.push(directorArr1);
        }
    } else {
        let directorArr1 = {
            companyName: '',
            companyNameRelevance: '',
            companyNameRelevanceRemarks: '',

            panCompany: '',
            panCompanyRelevance: '',
            panCompanyRelevanceRemarks: '',

            shares: '',
            sharesRelevance: '',
            sharesRelevanceRemarks: '',

            din: '',
            compDinRelevance: '',
            compDinRelevanceRemarks: '',
        };
        directorArr.push(directorArr1);
    }
    initialValues.directorCompany = directorArr;

    let travelOutsideArr = [];
    if (checklist1que && checklist1que[4].subQuestion[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[4].subQuestion[0].fields.length; i += 2) {
            let travelOutsideArrtemp = {
                year: checklist1que[4].subQuestion[0].fields[i].response,
                yearRelevance: checklist1que[4].subQuestion[0].fields[i].relevanceResponseCRC,
                yearRelevanceRemarks: checklist1que[4].subQuestion[0].fields[i].relevanceRemarksCRC,
                daysIndia: checklist1que[4].subQuestion[0].fields[i + 1].response,
                daysIndiaRelevance: checklist1que[4].subQuestion[0].fields[i + 1].relevanceResponseCRC,
                daysIndiaRelevanceRemarks: checklist1que[4].subQuestion[0].fields[i + 1].relevanceRemarksCRC,
            };
            travelOutsideArr.push(travelOutsideArrtemp);
        }
    } else {
        let travelOutsideArrtemp = {
            year: '',
            yearRelevance: '',
            yearRelevanceRemarks: '',
            daysIndia: '',
            daysIndiaRelevance: '',
            daysIndiaRelevanceRemarks: '',
        };
        travelOutsideArr.push(travelOutsideArrtemp);
    }
    initialValues.travelOutside = travelOutsideArr;

    let bankDetailsArr = [];

    if (dbValuesfromDB && dbValuesfromDB[1].fields.length > 0) {
        for (let i = 0; i < dbValuesfromDB[1].fields.length; i += 7) {
            let bankDetailsArrtemp = {
                bankName: dbValuesfromDB[1].fields[i].response,
                bankNameRelevance: dbValuesfromDB[1].fields[i].relevanceResponseCRC,
                bankNameRelevanceRemarks: dbValuesfromDB[1].fields[i].relevanceRemarksCRC,

                accountNumber: dbValuesfromDB[1].fields[i + 1].response,
                accountNoRelevance: dbValuesfromDB[1].fields[i + 1].relevanceResponseCRC,
                accountNoRelevanceRemarks: dbValuesfromDB[1].fields[i + 1].relevanceRemarksCRC,

                ifscCode: dbValuesfromDB[1].fields[i + 2].response,
                ifscCodeRelevance: dbValuesfromDB[1].fields[i + 2].relevanceResponseCRC,
                ifscCodeRelevanceRemarks: dbValuesfromDB[1].fields[i + 2].relevanceRemarksCRC,

                typeOfAcc: dbValuesfromDB[1].fields[i + 3].response,
                accTypeRelevance: dbValuesfromDB[1].fields[i + 3].relevanceResponseCRC,
                accTypeRelevanceRemarks: dbValuesfromDB[1].fields[i + 3].relevanceRemarksCRC,

                interestOfSavingsBank: dbValuesfromDB[1].fields[i + 4].response,
                jointAccNameRelevance: dbValuesfromDB[1].fields[i + 4].relevanceResponseCRC,
                jointAccNameRelevanceRemarks: dbValuesfromDB[1].fields[i + 4].relevanceRemarksCRC,

                checkedBank: dbValuesfromDB[1].fields[i + 5].response,
                checkedBankRelevance: dbValuesfromDB[1].fields[i + 5].relevanceResponseCRC,
                checkedBankRelevanceRemarks: dbValuesfromDB[1].fields[i + 5].relevanceRemarksCRC,

                bankStatementUpload:
                    checklist1que && checklist1que[1] && checklist1que[1].fields[i + 6] && checklist1que[1].fields[i + 6].response,
            };
            bankDetailsArr.push(bankDetailsArrtemp);
        }
    } else {
        let bankDetailsArrtemp = {
            bankName: '',
            bankNameRelevance: '',
            bankNameRelevanceRemarks: '',

            accountNumber: '',
            accountNoRelevance: '',
            accountNoRelevanceRemarks: '',

            ifscCode: '',
            ifscCodeRelevance: '',
            ifscCodeRelevanceRemarks: '',

            typeOfAcc: '',
            accTypeRelevance: '',
            accTypeRelevanceRemarks: '',

            interestOfSavingsBank: '',
            jointAccNameRelevance: '',
            jointAccNameRelevanceRemarks: '',

            checkedBank: '',
            checkedBankRelevance: '',
            checkedBankRelevanceRemarks: '',

            bankStatementUpload: '',
        };
        bankDetailsArr.push(bankDetailsArrtemp);
    }
    initialValues.bankDetails = bankDetailsArr;

    // screen 3 - Tab 6 - Deduction
    const investmentArr1 = [];

    if (checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[6].subSubQuestions[0].fields.length; i += 3) {
            let investmentArrtemp = {
                investmentDetails: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i].response,
                investmentDetailsCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i].relevanceResponseCRC,
                investmentDetailsCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i].relevanceRemarksCRC,
                investmentAmt: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i + 1].response,
                investmentAmtCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i + 1].relevanceResponseCRC,
                investmentAmtCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i + 1].relevanceRemarksCRC,
                invAmtUpload: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[0].fields[i + 2].response,
            };
            investmentArr1.push(investmentArrtemp);
        }
    } else {
        const investmentArrtemp = {
            investmentDetails: '',
            investmentAmt: '',
            invAmtUpload: '',
        };
        investmentArr1.push(investmentArrtemp);
    }
    initialValues.investment1 = investmentArr1;

    const donationArr1 = [];

    if (checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields.length > 0) {
        for (let i = 0; i < checklist1que[2].subQuestion[6].subSubQuestions[1].fields.length; i += 3) {
            const donationArrtemp = {
                donationDetails: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i].response,
                donationDetailsCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i].relevanceResponseCRC,
                donationDetailsCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i].relevanceRemarksCRC,
                donationAmt: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i + 1].response,
                donationAmountCRCRelevenceResponse:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i + 1].relevanceResponseCRC,
                donationAmountCRCRelevenceRemarks:
                    checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i + 1].relevanceRemarksCRC,
                donationAmtUpload: checklist1que && checklist1que[2].subQuestion[6].subSubQuestions[1].fields[i + 2].response,
            };
            donationArr1.push(donationArrtemp);
        }
    } else {
        const donationArrtemp = {
            donationDetails: '',
            donationAmt: '',
            donationAmtUpload: '',
        };
        donationArr1.push(donationArrtemp);
    }
    initialValues.donation1 = donationArr1;

    const validationSchema = Yup.object().shape({
        client4: Yup.array().of(
            Yup.object().shape({
                institutionName: Yup.string().required('Please Enter Institution Name'),
                institutionAddr: Yup.string().required('Please Enter Instituion Address'),
                accholderName: Yup.string()
                    // .matches(/^[A-Z]{1}[A-Za-z ]+$/, 'First letter should be in capital', 'Please Enter Valid AccountHolder Name')
                    // .matches(/^[A-Za-z ]+$/, 'First letter should be in capital', 'Please Enter Valid AccountHolder Name')
                    .required('Please Enter AccountHolder Name'),
                accountNumber: Yup.string()
                    .matches(/^\d{9,18}$/, 'Enter Valid Account Number')
                    .required('Please Enter AccountNumber'),
                peakBal: Yup.string()
                    .matches(/^[0-9\,]+$/, 'Enter digits only')
                    .required('Please Enter Peak Balance'),
            })
        ),
    });
    const handleSubmit = (values) => {
        if (statusIDValue === 2) {
            let tempObj = {};
            files.filter((ele, i) => {
                if (ele.filePath) {
                    tempObj = {
                        questionId: '',
                        questionText: 'uploadFile',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        response: ele.filePath,
                    };
                }
                if (!ele.filePath) {
                    tempObj = {
                        questionId: '',
                        questionText: 'uploadFile',
                        relevanceRemarksCRC: '',
                        relevanceResponseAM: '',
                        response: '',
                    };
                }
                values.remarks.push(tempObj);
            });
        }

        const data = {
            // Screen 1
            firstName: checklist1 && checklist1.questions[0].fields[0].response,
            firstnameRelevance: checklist1 && checklist1.questions[0].fields[0].relevanceResponseCRC,
            firstnameRelevanceRemarks: checklist1 && checklist1.questions[0].fields[0].relevanceRemarksCRC,

            lastName: checklist1 && checklist1.questions[0].fields[1].response,
            lastnameRelevance: checklist1 && checklist1.questions[0].fields[1].relevanceResponseCRC,
            lastnameRelevanceRemarks: checklist1 && checklist1.questions[0].fields[1].relevanceRemarksCRC,

            fatherNamePan: checklist1 && checklist1.questions[0].fields[2].response,
            fatherNamePanRelevance: checklist1 && checklist1.questions[0].fields[2].relevanceResponseCRC,
            fatherNamePanRelevanceRemarks: checklist1 && checklist1.questions[0].fields[2].relevanceRemarksCRC,

            pan: checklist1 && checklist1.questions[0].fields[3].response,
            panRelevance: checklist1 && checklist1.questions[0].fields[3].relevanceResponseCRC,
            panRelevanceRemarks: checklist1 && checklist1.questions[0].fields[3].relevanceRemarksCRC,

            address1: checklist1 && checklist1.questions[0].fields[4].response,
            address1Relevance: checklist1 && checklist1.questions[0].fields[4].relevanceResponseCRC,
            address1RelevanceRemarks: checklist1 && checklist1.questions[0].fields[4].relevanceRemarksCRC,

            address2: checklist1 && checklist1.questions[0].fields[5].response,
            address2Relevance: checklist1 && checklist1.questions[0].fields[5].relevanceResponseCRC,
            address2RelevanceRemarks: checklist1 && checklist1.questions[0].fields[5].relevanceRemarksCRC,

            city: checklist1 && checklist1.questions[0].fields[6].response,
            cityRelevance: checklist1 && checklist1.questions[0].fields[6].relevanceResponseCRC,
            cityRelevanceRemarks: checklist1 && checklist1.questions[0].fields[6].relevanceRemarksCRC,

            state: checklist1 && checklist1.questions[0].fields[7].response,
            stateRelevance: checklist1 && checklist1.questions[0].fields[7].relevanceResponseCRC,
            stateRelevanceRemarks: checklist1 && checklist1.questions[0].fields[7].relevanceRemarksCRC,

            country: checklist1 && checklist1.questions[0].fields[8].response,
            countryRelevance: checklist1 && checklist1.questions[0].fields[8].relevanceResponseCRC,
            countryRelevanceRemarks: checklist1 && checklist1.questions[0].fields[8].relevanceRemarksCRC,

            pin: checklist1 && checklist1.questions[0].fields[9].response,
            pinRelevance: checklist1 && checklist1.questions[0].fields[9].relevanceResponseCRC,
            pinRelevanceRemarks: checklist1 && checklist1.questions[0].fields[9].relevanceRemarksCRC,

            dob: checklist1 && checklist1.questions[0].fields[10].response,
            dobRelevance: checklist1 && checklist1.questions[0].fields[10].relevanceResponseCRC,
            dobRelevanceRemarks: checklist1 && checklist1.questions[0].fields[10].relevanceRemarksCRC,

            mobileNo: checklist1 && checklist1.questions[0].fields[11].response,
            mobileNoRelevance: checklist1 && checklist1.questions[0].fields[11].relevanceResponseCRC,
            mobileNoRelevanceRemarks: checklist1 && checklist1.questions[0].fields[11].relevanceRemarksCRC,

            emailaddress: checklist1 && checklist1.questions[0].fields[12].response,
            emailaddressRelevance: checklist1 && checklist1.questions[0].fields[12].relevanceResponseCRC,
            emailaddressRelevanceRemarks: checklist1 && checklist1.questions[0].fields[12].relevanceRemarksCRC,

            passport: checklist1 && checklist1.questions[0].fields[13].response,
            passportRelevance: checklist1 && checklist1.questions[0].fields[13].relevanceResponseCRC,
            passportRelevanceRemarks: checklist1 && checklist1.questions[0].fields[13].relevanceRemarksCRC,

            govIDType: checklist1 && checklist1.questions[0].fields[14].response,

            govIDNumber: checklist1 && checklist1.questions[0].fields[15].response,
            govIDNumberRelevance: checklist1 && checklist1.questions[0].fields[15].relevanceResponseCRC,
            govIDNumberRelevanceRemarks: checklist1 && checklist1.questions[0].fields[15].relevanceRemarksCRC,

            URLValue: checklist1 && checklist1.questions[0].fields[16].response,

            radiodata: checklist1 && checklist1.questions[0].fields[17].response,

            GSTIN: checklist1 && checklist1.questions[0].fields[18].response,
            gstinRelevance: checklist1 && checklist1.questions[0].fields[18].relevanceResponseCRC,
            gstinRelevanceRemarks: checklist1 && checklist1.questions[0].fields[18].relevanceRemarksCRC,
            panFile:
                checklist1 &&
                checklist1.questions &&
                checklist1.questions[0] &&
                checklist1.questions[0].fields &&
                checklist1.questions[0].fields[19] &&
                checklist1.questions[0].fields[19].response,
            aadharFile:
                checklist1 &&
                checklist1.questions &&
                checklist1.questions[0] &&
                checklist1.questions[0].fields &&
                checklist1.questions[0].fields[20] &&
                checklist1.questions[0].fields[20].response,
            enrollmentFile:
                checklist1 &&
                checklist1.questions &&
                checklist1.questions[0] &&
                checklist1.questions[0].fields &&
                checklist1.questions[0].fields[21] &&
                checklist1.questions[0].fields[21].response,
            gstFile:
                checklist1 &&
                checklist1.questions &&
                checklist1.questions[0] &&
                checklist1.questions[0].fields &&
                checklist1.questions[0].fields[22] &&
                checklist1.questions[0].fields[22].response,

            // URLValue: URLValue,

            // Scrren 2
            bankDetails: values.bankDetails,
            // screen 3 - Tab 1 - Salary
            nameEmployer: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[1].response,
            nameEmployerCRCrelevenceResponse:
                checklist1 && checklist1.questions[2].subQuestion[0].subSubQuestions[0].fields[1].relevanceResponseCRC,
            nameEmployerCRCrelevenceRemarks:
                checklist1 && checklist1.questions[2].subQuestion[0].subSubQuestions[0].fields[1].relevanceRemarksCRC,
            url: checklist1 && checklist1.questions[2].subQuestion[0].subSubQuestions[0].fields[2].response,
            salaryradiodata: checklist1que && checklist1que[2].subQuestion[0].subSubQuestions[0].fields[0].response,
            investment: values.investment,
            donation: values.donation,
            // screen 3 - Tab 2 - House prop
            houseproperty: values.houseproperty,
            incomeFromHouseProperty: values.incomeFromHouseProperty,
            // screen 3 - Tab 3 - Business
            incomeFromBusinessProfesion: values.incomeFromBusinessProfesion,

            natureBusiness: values.natureBusiness,
            natureBusinessCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[0].relevanceResponseCRC,
            natureBusinessCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[0].relevanceRemarksCRC,

            busProfincomeType: values.busProfincomeType,
            busProfincomeTypeCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[1].relevanceResponseCRC,
            busProfincomeTypeCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[1].relevanceRemarksCRC,

            totalReceipts: values.totalReceipts,
            totalReceiptsCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[2].relevanceResponseCRC,
            totalReceiptsCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[2].relevanceRemarksCRC,

            totalExpenses: values.totalExpenses,
            totalExpensesCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[3].relevanceResponseCRC,
            totalExpensesCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[3].relevanceRemarksCRC,

            gstReturnDoc: values.gstReturnDoc,
            gstReturnDocCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[4].relevanceResponseCRC,
            gstReturnDocCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[4].relevanceRemarksCRC,

            otherStatement: values.otherStatement,
            otherStatementCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[5].relevanceResponseCRC,
            otherStatementCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[5].relevanceRemarksCRC,

            busProfType: values.busProfType,
            busProfTypeCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[6].relevanceResponseCRC,
            busProfTypeCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[6].relevanceRemarksCRC,

            userIDtally: values.userIDtally,
            userIDtallyCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[7].relevanceResponseCRC,
            userIDtallyCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[7].relevanceRemarksCRC,

            passwordtally: values.passwordtally,
            passwordtallyCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[8].relevanceResponseCRC,
            passwordtallyCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[8].relevanceRemarksCRC,

            uploadTally: values.uploadTally,
            uploadTallyCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[9].relevanceResponseCRC,
            uploadTallyCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[9].relevanceRemarksCRC,

            userIDZoho: values.userIDZoho,
            userIDZohoCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[10].relevanceResponseCRC,
            userIDZohoCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[10].relevanceRemarksCRC,

            passwordZoho: values.passwordZoho,
            passwordZohoCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[11].relevanceResponseCRC,
            passwordZohoCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[11].relevanceRemarksCRC,

            accountDetails: values.accountDetails,
            accountDetailsCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[12].relevanceResponseCRC,
            accountDetailsCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[12].relevanceRemarksCRC,

            partnershipradio: values.partnershipradio,
            partnershipradioCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[13].relevanceResponseCRC,
            partnershipradioCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[13].relevanceRemarksCRC,

            tallyYes: values.tallyYes,
            totalReceiptsUpload: values.totalReceiptsUpload,
            totalExpensesUpload: values.totalExpensesUpload,
            gstUpload: values.gstUpload,
            statementUpload: values.statementUpload,

            userIDQB: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].response,
            userIDQBCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].relevanceResponseCRC,
            userIDQBCRCrelevenceRemarks: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[18].relevanceRemarksCRC,

            passwordQB: checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].response,
            passwordQBCRCrelevenceResponse:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].relevanceResponseCRC,
            passwordQBCRCrelevenceRemarks:
                checklist1que && checklist1que[2].subQuestion[2].subSubQuestions[0].fields[19].relevanceRemarksCRC,

            // screen 3 - Tab 4 -capitl gain
            capitalgain: values.capitalgain,
            soldAnyAsset: values.soldAnyAsset,
            // screen 3 -Tab 5 - other sources
            divident: values.divident,
            fd: values.fd,
            othersources: values.othersources,
            explicitlyUncoveredIncom: values.explicitlyUncoveredIncom,
            // screen 3 - Tab 6 - Agri
            agricultureIncome: values.agricultureIncome,
            agriculture: values.agriculture,
            // agricultureName: values.agricultureName,
            // agriAmount: values.agriAmount,
            // agriReceipt: values.agriReceipt,
            // agriExpenses: values.agriExpenses,
            // agriExpensesUpload: values.agriExpensesUpload,
            // agriReceiptUpload: values.agriReceiptUpload,
            // Screen 4
            incomeTaxType: checklist1 && checklist1.questions[3].fields[0].response,
            incomeUserId: checklist1 && checklist1.questions[3].fields[1].response,
            userIdRelevance: checklist1 && checklist1.questions[3].fields[1].relevanceResponseCRC,
            userIdRelevanceRemarks: checklist1 && checklist1.questions[3].fields[1].relevanceRemarksCRC,
            incomePassword: checklist1 && checklist1.questions[3].fields[2].response,
            passwordRelevance: checklist1 && checklist1.questions[3].fields[2].relevanceResponseCRC,
            passwordRelevanceRemarks: checklist1 && checklist1.questions[3].fields[2].relevanceRemarksCRC,
            // Screen 5
            // traveloutsideType: checklist1 && checklist1.questions[4].fields[0].response,
            traveloutsideType: values.traveloutsideType,
            travelOutside: values.travelOutside,
            // Screen 6
            // directorType: checklist1 && checklist1.questions[5].fields[0].response,
            directorType: values.directorType,
            directorCompany: values.directorCompany,
            // Screen 7
            assetradio: values.assetradio,
            client10: values.client10,
            client9: values.client9,
            client8: values.client8,
            client7: values.client7,
            client6: values.client6,
            client5: values.client5,
            client4: values.client4,
            client3: values.client3,
            client2: values.client2,
            client1: values.client1,
            assetHome: values.assetHome,
            assetNature: values.assetNature,
            // Screen 8
            labelEdata: values.labelEdata,
            labelDdata: values.labelDdata,
            labelCdata: values.labelCdata,
            labelBdata: values.labelBdata,
            labelAdata: values.labelAdata,
            totalincomeradio: values.totalincomeradio,

            // additionalQue: checklist && checklist.additionalQuestion != null ? values.remarks : null,

            additionalQue:
                statusIDValue === 2
                    ? checklist && checklist.additionalQuestion != null
                        ? values.remarks
                        : null
                    : checklist1que && checklist1que[8].subQuestion[0].fields != null
                    ? values.remarks
                    : null,

            investment1: values.investment1,
            donation1: values.donation1,
        };
        //console.log('client4...data', data);

        // dispatch(createClientAccordian4Request({ params: data }));
        setShowLoader(true);
        dispatch(createGenInfoRequestSave({ params: data, bearerToken, serviceIdValue, usertype, tennantnameValue }));
        setTimeout(() => {
            setShowLoader(false);
            axios
                .get(
                    `${CommonConfig.dev.baseUrl1}/api/itr/checklist-by-serviceId/${
                        usertype === 'Ultimate Client' || usertype === 'EM' ? tennantnameValue : imcNameSelected
                    }/${serviceIdValue}`,
                    {
                        headers: {
                            Authorization: bearerToken,
                        },
                    }
                )
                .then((response) => {
                    // setChecklist(response.data);
                    console.log('temp', response.data);

                    let temp = dataValidationAssetsCheck(response.data, statusId);
                    console.log('temp', temp);
                })
                .catch((error) => {});
            props.handleAccordChange('panel5');
        }, 3000);
    };

    const handleClose = () => {
        setShowLoader(false);
    };

    return (
        <>
            {showLoader ? <LoaderPopUp showLoader={showLoader} handleClose={handleClose} /> : null}
            <div className={classes.root}>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={(values) => handleSubmit(values)}
                    enableReinitialize
                >
                    {(formik) => {
                        return (
                            <form onSubmit={formik.handleSubmit}>
                                <Grid container spacing={2} className="main-container">
                                    <FieldArray name="client4">
                                        {(fieldArrayProps) => {
                                            const { push, remove, form } = fieldArrayProps;
                                            const { values } = form;
                                            const { client4 } = values;
                                            let key = 0;
                                            return (
                                                <>
                                                    {client4.map((client4Item, client4Index) => {
                                                        key++;
                                                        return (
                                                            <Fragment key={key}>
                                                                <div className="field-divider">{client4Index > 0 && <hr />}</div>
                                                                <Grid item xs={12} sm={6} md={6} className={classes.marginBtm}>
                                                                    <FormControl fullWidth className={classes.margin}>
                                                                        <InputLabel
                                                                            className={classes.inLabel}
                                                                            htmlFor="institution-name"
                                                                            shrink
                                                                        >
                                                                            Name of the institution in which the account is held{' '}
                                                                            <span style={{ color: '#ff0a047a' }}>*</span>
                                                                        </InputLabel>
                                                                        <Field name={`client4[${client4Index}].institutionName`}>
                                                                            {(fieldProps) => {
                                                                                const { field, meta } = fieldProps;
                                                                                return (
                                                                                    <>
                                                                                        <Input
                                                                                            className={classes.bottomLine}
                                                                                            placeholder="Enter Institution Name"
                                                                                            {...field}
                                                                                            disabled={fieldDisable(
                                                                                                statusId,
                                                                                                checklist1 &&
                                                                                                    checklist1.questions &&
                                                                                                    checklist1.questions[6] &&
                                                                                                    checklist1.questions[6].subQuestion &&
                                                                                                    checklist1.questions[6]
                                                                                                        .subQuestion[4] &&
                                                                                                    checklist1.questions[6].subQuestion[4]
                                                                                                        .fields &&
                                                                                                    checklist1.questions[6].subQuestion[4]
                                                                                                        .fields[1].relevanceResponseCRC
                                                                                            )}
                                                                                        />
                                                                                        {/* <Select
                                                                                            native
                                                                                            id="institution-name"
                                                                                            className={classes.bottomLine}
                                                                                            placeholder="Enter Institution Name"
                                                                                            {...field}
                                                                                            disabled={fieldDisable(
                                                                                                statusId,
                                                                                                checklist1 &&
                                                                                                    checklist1.questions &&
                                                                                                    checklist1.questions[6] &&
                                                                                                    checklist1.questions[6].subQuestion &&
                                                                                                    checklist1.questions[6]
                                                                                                        .subQuestion[4] &&
                                                                                                    checklist1.questions[6].subQuestion[4]
                                                                                                        .fields &&
                                                                                                    checklist1.questions[6].subQuestion[4]
                                                                                                        .fields[0].relevanceResponseCRC
                                                                                            )}
                                                                                           
                                                                                            IconComponent={() => (
                                                                                                <FontAwesomeIcon
                                                                                                    cursor="pointer"
                                                                                                    icon={faAngleDown}
                                                                                                />
                                                                                            )}
                                                                                            onChange={(e) => {
                                                                                                setCountry(e);
                                                                                                formik.handleChange(e);
                                                                                            }}
                                                                                        >
                                                                                            <option aria-label="None" value="">
                                                                                                Select Country
                                                                                            </option>
                                                                                            {allCountryOptions(allCountries)}
                                                                                            
                                                                                        </Select> */}
                                                                                        {meta.touched && meta.error ? (
                                                                                            <span className="itec-validationError">
                                                                                                {meta.error}
                                                                                            </span>
                                                                                        ) : null}
                                                                                    </>
                                                                                );
                                                                            }}
                                                                        </Field>
                                                                        <div>
                                                                            <Typography className={classes.bottomLine}>
                                                                                {statusId === 6 &&
                                                                                    userType.value === 'L2 Checklist' &&
                                                                                    checklist1 &&
                                                                                    (checklist1.questions[6].subQuestion[4].fields[0]
                                                                                        .relevanceResponseCRC === 'Relevant' ? (
                                                                                        <div className={classes.relevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[0].relevanceRemarksCRC}{' '}
                                                                                        </div>
                                                                                    ) : checklist1.questions[6].subQuestion[4].fields[0]
                                                                                          .relevanceResponseCRC === 'Irrelavant' ? (
                                                                                        <div className={classes.irrelevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[0].relevanceRemarksCRC}{' '}
                                                                                        </div>
                                                                                    ) : checklist1.questions[6].subQuestion[4].fields[0]
                                                                                          .relevanceResponseCRC ===
                                                                                      'Paritially Relevant' ? (
                                                                                        <div className={classes.partrelevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[0].relevanceRemarksCRC}
                                                                                        </div>
                                                                                    ) : (
                                                                                        ''
                                                                                    ))}
                                                                            </Typography>
                                                                        </div>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} md={6} className={classes.marginBtm}>
                                                                    <FormControl fullWidth className={classes.margin}>
                                                                        <InputLabel
                                                                            className={classes.inLabel}
                                                                            htmlFor="institution-addr"
                                                                            shrink
                                                                        >
                                                                            Address of the institution{' '}
                                                                            <span style={{ color: '#ff0a047a' }}>*</span>
                                                                        </InputLabel>
                                                                        <Field name={`client4[${client4Index}].institutionAddr`}>
                                                                            {(fieldProps) => {
                                                                                const { field, meta } = fieldProps;
                                                                                return (
                                                                                    <>
                                                                                        <Input
                                                                                            className={classes.bottomLine}
                                                                                            placeholder="Enter Institution Address"
                                                                                            {...field}
                                                                                            disabled={fieldDisable(
                                                                                                statusId,
                                                                                                checklist1 &&
                                                                                                    checklist1.questions &&
                                                                                                    checklist1.questions[6] &&
                                                                                                    checklist1.questions[6].subQuestion &&
                                                                                                    checklist1.questions[6]
                                                                                                        .subQuestion[4] &&
                                                                                                    checklist1.questions[6].subQuestion[4]
                                                                                                        .fields &&
                                                                                                    checklist1.questions[6].subQuestion[4]
                                                                                                        .fields[1].relevanceResponseCRC
                                                                                            )}
                                                                                            // disabled={
                                                                                            //     statusId === 6 &&
                                                                                            //         checklist1 &&
                                                                                            //         checklist1.questions[6].subQuestion[4].fields[1]
                                                                                            //             .relevanceResponseCRC === 'Relevant'
                                                                                            //         ? 'disabled'
                                                                                            //         : ''
                                                                                            // }
                                                                                        />
                                                                                        {meta.touched && meta.error ? (
                                                                                            <span className="itec-validationError">
                                                                                                {meta.error}
                                                                                            </span>
                                                                                        ) : null}
                                                                                    </>
                                                                                );
                                                                            }}
                                                                        </Field>
                                                                        <div>
                                                                            <Typography className={classes.bottomLine}>
                                                                                {statusId === 6 &&
                                                                                    userType.value === 'L2 Checklist' &&
                                                                                    checklist1 &&
                                                                                    (checklist1.questions[6].subQuestion[4].fields[1]
                                                                                        .relevanceResponseCRC === 'Relevant' ? (
                                                                                        <div className={classes.relevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[1].relevanceRemarksCRC}{' '}
                                                                                        </div>
                                                                                    ) : checklist1.questions[6].subQuestion[4].fields[1]
                                                                                          .relevanceResponseCRC === 'Irrelavant' ? (
                                                                                        <div className={classes.irrelevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[1].relevanceRemarksCRC}{' '}
                                                                                        </div>
                                                                                    ) : checklist1.questions[6].subQuestion[4].fields[1]
                                                                                          .relevanceResponseCRC ===
                                                                                      'Paritially Relevant' ? (
                                                                                        <div className={classes.partrelevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[1].relevanceRemarksCRC}
                                                                                        </div>
                                                                                    ) : (
                                                                                        ''
                                                                                    ))}
                                                                            </Typography>
                                                                        </div>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} md={6} className={classes.marginBtm}>
                                                                    <FormControl fullWidth className={classes.margin}>
                                                                        <InputLabel
                                                                            className={classes.inLabel}
                                                                            htmlFor="acholder-name"
                                                                            shrink
                                                                        >
                                                                            Name of the account holder{' '}
                                                                            <span style={{ color: '#ff0a047a' }}>*</span>
                                                                        </InputLabel>
                                                                        <Field name={`client4[${client4Index}].accholderName`}>
                                                                            {(fieldProps) => {
                                                                                const { field, meta } = fieldProps;
                                                                                return (
                                                                                    <>
                                                                                        <Input
                                                                                            className={classes.bottomLine}
                                                                                            placeholder="Enter Account Holder Name"
                                                                                            {...field}
                                                                                            disabled={fieldDisable(
                                                                                                statusId,
                                                                                                checklist1 &&
                                                                                                    checklist1.questions &&
                                                                                                    checklist1.questions[6] &&
                                                                                                    checklist1.questions[6].subQuestion &&
                                                                                                    checklist1.questions[6]
                                                                                                        .subQuestion[4] &&
                                                                                                    checklist1.questions[6].subQuestion[4]
                                                                                                        .fields &&
                                                                                                    checklist1.questions[6].subQuestion[4]
                                                                                                        .fields[2].relevanceResponseCRC
                                                                                            )}
                                                                                            // disabled={
                                                                                            //     statusId === 6 &&
                                                                                            //         checklist1 &&
                                                                                            //         checklist1.questions[6].subQuestion[4].fields[2]
                                                                                            //             .relevanceResponseCRC === 'Relevant'
                                                                                            //         ? 'disabled'
                                                                                            //         : ''
                                                                                            // }
                                                                                        />
                                                                                        {meta.touched && meta.error ? (
                                                                                            <span className="itec-validationError">
                                                                                                {meta.error}
                                                                                            </span>
                                                                                        ) : null}
                                                                                    </>
                                                                                );
                                                                            }}
                                                                        </Field>
                                                                        <div>
                                                                            <Typography className={classes.bottomLine}>
                                                                                {statusId === 6 &&
                                                                                    userType.value === 'L2 Checklist' &&
                                                                                    checklist1 &&
                                                                                    (checklist1.questions[6].subQuestion[4].fields[2]
                                                                                        .relevanceResponseCRC === 'Relevant' ? (
                                                                                        <div className={classes.relevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[2].relevanceRemarksCRC}{' '}
                                                                                        </div>
                                                                                    ) : checklist1.questions[6].subQuestion[4].fields[2]
                                                                                          .relevanceResponseCRC === 'Irrelavant' ? (
                                                                                        <div className={classes.irrelevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[2].relevanceRemarksCRC}{' '}
                                                                                        </div>
                                                                                    ) : checklist1.questions[6].subQuestion[4].fields[2]
                                                                                          .relevanceResponseCRC ===
                                                                                      'Paritially Relevant' ? (
                                                                                        <div className={classes.partrelevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[2].relevanceRemarksCRC}
                                                                                        </div>
                                                                                    ) : (
                                                                                        ''
                                                                                    ))}
                                                                            </Typography>
                                                                        </div>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} md={6} className={classes.marginBtm}>
                                                                    <FormControl fullWidth className={classes.margin}>
                                                                        <InputLabel
                                                                            className={classes.inLabel}
                                                                            htmlFor="account-number"
                                                                            shrink
                                                                        >
                                                                            Account Number <span style={{ color: '#ff0a047a' }}>*</span>
                                                                        </InputLabel>
                                                                        <Field name={`client4[${client4Index}].accountNumber`}>
                                                                            {(fieldProps) => {
                                                                                const { field, meta } = fieldProps;
                                                                                return (
                                                                                    <>
                                                                                        <Input
                                                                                            className={classes.bottomLine}
                                                                                            placeholder="Enter Account Number"
                                                                                            {...field}
                                                                                            disabled={fieldDisable(
                                                                                                statusId,
                                                                                                checklist1 &&
                                                                                                    checklist1.questions &&
                                                                                                    checklist1.questions[6] &&
                                                                                                    checklist1.questions[6].subQuestion &&
                                                                                                    checklist1.questions[6]
                                                                                                        .subQuestion[4] &&
                                                                                                    checklist1.questions[6].subQuestion[4]
                                                                                                        .fields &&
                                                                                                    checklist1.questions[6].subQuestion[4]
                                                                                                        .fields[3].relevanceResponseCRC
                                                                                            )}
                                                                                            // disabled={
                                                                                            //     statusId === 6 &&
                                                                                            //         checklist1 &&
                                                                                            //         checklist1.questions[6].subQuestion[4].fields[3]
                                                                                            //             .relevanceResponseCRC === 'Relevant'
                                                                                            //         ? 'disabled'
                                                                                            //         : ''
                                                                                            // }
                                                                                        />
                                                                                        {meta.touched && meta.error ? (
                                                                                            <span className="itec-validationError">
                                                                                                {meta.error}
                                                                                            </span>
                                                                                        ) : null}
                                                                                    </>
                                                                                );
                                                                            }}
                                                                        </Field>
                                                                        <div>
                                                                            <Typography className={classes.bottomLine}>
                                                                                {statusId === 6 &&
                                                                                    userType.value === 'L2 Checklist' &&
                                                                                    checklist1 &&
                                                                                    (checklist1.questions[6].subQuestion[4].fields[3]
                                                                                        .relevanceResponseCRC === 'Relevant' ? (
                                                                                        <div className={classes.relevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[3].relevanceRemarksCRC}{' '}
                                                                                        </div>
                                                                                    ) : checklist1.questions[6].subQuestion[4].fields[3]
                                                                                          .relevanceResponseCRC === 'Irrelavant' ? (
                                                                                        <div className={classes.irrelevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[3].relevanceRemarksCRC}{' '}
                                                                                        </div>
                                                                                    ) : checklist1.questions[6].subQuestion[4].fields[3]
                                                                                          .relevanceResponseCRC ===
                                                                                      'Paritially Relevant' ? (
                                                                                        <div className={classes.partrelevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[3].relevanceRemarksCRC}
                                                                                        </div>
                                                                                    ) : (
                                                                                        ''
                                                                                    ))}
                                                                            </Typography>
                                                                        </div>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} sm={6} md={6} className={classes.marginBtm}>
                                                                    <FormControl fullWidth className={classes.margin}>
                                                                        <InputLabel className={classes.inLabel} htmlFor="peak-bal" shrink>
                                                                            Peak Balance/ Investment/ During the year (in Rs.){' '}
                                                                            <span style={{ color: '#ff0a047a' }}>*</span>
                                                                        </InputLabel>
                                                                        <Field name={`client4[${client4Index}].peakBal`}>
                                                                            {(fieldProps) => {
                                                                                const { field, meta } = fieldProps;
                                                                                return (
                                                                                    <>
                                                                                        <Input
                                                                                            onInput={(e) => handleStateChange(e)}
                                                                                            className={classes.bottomLine}
                                                                                            placeholder="Enter Peak Balance"
                                                                                            {...field}
                                                                                            disabled={fieldDisable(
                                                                                                statusId,
                                                                                                checklist1 &&
                                                                                                    checklist1.questions &&
                                                                                                    checklist1.questions[6] &&
                                                                                                    checklist1.questions[6].subQuestion &&
                                                                                                    checklist1.questions[6]
                                                                                                        .subQuestion[4] &&
                                                                                                    checklist1.questions[6].subQuestion[4]
                                                                                                        .fields &&
                                                                                                    checklist1.questions[6].subQuestion[4]
                                                                                                        .fields[4].relevanceResponseCRC
                                                                                            )}
                                                                                            // disabled={
                                                                                            //     statusId === 6 &&
                                                                                            //         checklist1 &&
                                                                                            //         checklist1.questions[6].subQuestion[4].fields[4]
                                                                                            //             .relevanceResponseCRC === 'Relevant'
                                                                                            //         ? 'disabled'
                                                                                            //         : ''
                                                                                            // }
                                                                                        />
                                                                                        {meta.touched && meta.error ? (
                                                                                            <span className="itec-validationError">
                                                                                                {meta.error}
                                                                                            </span>
                                                                                        ) : null}
                                                                                    </>
                                                                                );
                                                                            }}
                                                                        </Field>
                                                                        <div>
                                                                            <Typography className={classes.bottomLine}>
                                                                                {statusId === 6 &&
                                                                                    userType.value === 'L2 Checklist' &&
                                                                                    checklist1 &&
                                                                                    (checklist1.questions[6].subQuestion[4].fields[4]
                                                                                        .relevanceResponseCRC === 'Relevant' ? (
                                                                                        <div className={classes.relevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[4].relevanceRemarksCRC}{' '}
                                                                                        </div>
                                                                                    ) : checklist1.questions[6].subQuestion[4].fields[4]
                                                                                          .relevanceResponseCRC === 'Irrelavant' ? (
                                                                                        <div className={classes.irrelevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[4].relevanceRemarksCRC}{' '}
                                                                                        </div>
                                                                                    ) : checklist1.questions[6].subQuestion[4].fields[4]
                                                                                          .relevanceResponseCRC ===
                                                                                      'Paritially Relevant' ? (
                                                                                        <div className={classes.partrelevanceIndicator}>
                                                                                            {checklist1 &&
                                                                                                checklist1.questions[6].subQuestion[4]
                                                                                                    .fields[4].relevanceRemarksCRC}
                                                                                        </div>
                                                                                    ) : (
                                                                                        ''
                                                                                    ))}
                                                                            </Typography>
                                                                        </div>
                                                                    </FormControl>
                                                                </Grid>
                                                                <Grid item xs={12} sm={12} className="gridAdd">
                                                                    <div className="addmore">
                                                                        {client4Index === client4.length - 1 && (
                                                                            <Button
                                                                                variant="outlined"
                                                                                color="primary"
                                                                                className="txt-capitalize btnSmallDevice"
                                                                                onClick={() => {
                                                                                    push({
                                                                                        institutionName: '',
                                                                                        institutionAddr: '',
                                                                                        accholderName: '',
                                                                                        accountNumber: '',
                                                                                        peakBal: '',
                                                                                    });
                                                                                }}
                                                                                disabled={fieldDisable(statusId, '')}
                                                                            >
                                                                                Add More
                                                                            </Button>
                                                                        )}
                                                                    </div>
                                                                    <div className="removemore">
                                                                        {client4.length !== 1 && (
                                                                            <Button
                                                                                variant="outlined"
                                                                                color="primary"
                                                                                className="txt-capitalize btnSmallDevice"
                                                                                onClick={() => {
                                                                                    remove(client4Index);
                                                                                }}
                                                                                x
                                                                                disabled={fieldDisable(statusId, '')}
                                                                            >
                                                                                Remove
                                                                            </Button>
                                                                        )}
                                                                    </div>
                                                                </Grid>
                                                            </Fragment>
                                                        );
                                                    })}
                                                </>
                                            );
                                        }}
                                    </FieldArray>
                                </Grid>

                                {panel == 'panel4' && (
                                    <Grid container spacing={3} direction="row" justify="space-between" alignItems="baseline">
                                        <Grid item sm={6} className="btnLeftPad"></Grid>
                                        <Grid item sm={6} className="textRightPT0">
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                className="txt-capitalize btnBlue"
                                                type="submit"
                                                disabled={fieldDisable(statusId, '')}
                                            >
                                                Save & Continue
                                            </Button>
                                        </Grid>
                                    </Grid>
                                )}
                            </form>
                        );
                    }}
                </Formik>
            </div>
        </>
    );
}
